export const editSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V9.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0299 2.26495L6.11991 8.17495C5.89491 8.39995 5.66991 8.84245 5.62491 9.16495L5.30241 11.4224C5.18241 12.2399 5.75991 12.8099 6.57741 12.6974L8.83491 12.3749C9.14991 12.3299 9.59241 12.1049 9.82491 11.8799L15.7349 5.96995C16.7549 4.94995 17.2349 3.76495 15.7349 2.26495C14.2349 0.764945 13.0499 1.24495 12.0299 2.26495Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1826 3.11255C11.6851 4.90505 13.0876 6.30755 14.8876 6.81755"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const hintSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M9 5.8125V9.75"
      stroke="#FFE629"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.81 6.43503V11.565C15.81 12.405 15.36 13.185 14.6325 13.6125L10.1775 16.185C9.45002 16.605 8.55 16.605 7.815 16.185L3.36 13.6125C2.6325 13.1925 2.1825 12.4125 2.1825 11.565V6.43503C2.1825 5.59503 2.6325 4.81499 3.36 4.38749L7.815 1.815C8.5425 1.395 9.44252 1.395 10.1775 1.815L14.6325 4.38749C15.36 4.81499 15.81 5.58753 15.81 6.43503Z"
      stroke="#FFE629"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 12.1499V12.2249"
      stroke="#FFE629"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const playSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6H6V12H12V6Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 16.5C4.9875 16.5 6 15.4875 6 14.25V12H3.75C2.5125 12 1.5 13.0125 1.5 14.25C1.5 15.4875 2.5125 16.5 3.75 16.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 6H6V3.75C6 2.5125 4.9875 1.5 3.75 1.5C2.5125 1.5 1.5 2.5125 1.5 3.75C1.5 4.9875 2.5125 6 3.75 6Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6H14.25C15.4875 6 16.5 4.9875 16.5 3.75C16.5 2.5125 15.4875 1.5 14.25 1.5C13.0125 1.5 12 2.5125 12 3.75V6Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 16.5C15.4875 16.5 16.5 15.4875 16.5 14.25C16.5 13.0125 15.4875 12 14.25 12H12V14.25C12 15.4875 13.0125 16.5 14.25 16.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const communitySvg = (
  <svg width="28" height="25" viewBox="0 0 28 25" fill="none">
    <path
      d="M17.7143 16.5713C18.3963 16.5713 19.0503 16.8422 19.5326 17.3244C20.0148 17.8067 20.2857 18.4607 20.2857 19.1427V20.8593L20.2766 20.9827C19.9223 23.4136 17.7394 24.5816 14.0766 24.5816C10.4274 24.5816 8.20914 23.4273 7.73028 21.025L7.71428 20.857V19.1427C7.71428 18.4607 7.9852 17.8067 8.46744 17.3244C8.94967 16.8422 9.60373 16.5713 10.2857 16.5713H17.7143ZM17.7143 18.2856H10.2857C10.0584 18.2856 9.84037 18.3759 9.67962 18.5366C9.51888 18.6974 9.42857 18.9154 9.42857 19.1427V20.7656C9.74857 22.137 11.2 22.8673 14.0766 22.8673C16.952 22.8673 18.3394 22.1461 18.5714 20.7919V19.1427C18.5714 18.9154 18.4811 18.6974 18.3204 18.5366C18.1596 18.3759 17.9416 18.2856 17.7143 18.2856ZM18.8503 9.713L25.1429 9.71415C25.8248 9.71415 26.4789 9.98506 26.9611 10.4673C27.4434 10.9495 27.7143 11.6036 27.7143 12.2856V14.0021L27.7051 14.1256C27.3509 16.5564 25.168 17.7244 21.5051 17.7244L21.1451 17.721C20.8077 16.9075 20.1925 16.2401 19.4091 15.8376C19.9977 15.9519 20.6949 16.0101 21.5051 16.0101C24.3806 16.0101 25.768 15.289 26 13.9347V12.2856C26 12.0582 25.9097 11.8402 25.7489 11.6795C25.5882 11.5187 25.3702 11.4284 25.1429 11.4284H19.1429C19.1429 10.8273 19.04 10.249 18.8503 9.713ZM2.85714 9.71415L9.14971 9.713C8.98833 10.1696 8.89252 10.6467 8.86514 11.1301L8.85714 11.4284H2.85714C2.62981 11.4284 2.4118 11.5187 2.25105 11.6795C2.0903 11.8402 2 12.0582 2 12.2856V13.9084C2.32 15.2799 3.77143 16.0101 6.648 16.0101C7.35886 16.0101 7.97828 15.9656 8.51314 15.8787C7.76509 16.2852 7.17899 16.9358 6.85257 17.7221L6.64686 17.7244C2.99886 17.7244 0.78057 16.5701 0.301713 14.1679L0.285713 13.9999V12.2856C0.285713 11.6036 0.556631 10.9495 1.03887 10.4673C1.5211 9.98506 2.17516 9.71415 2.85714 9.71415ZM14 7.42843C15.0609 7.42843 16.0783 7.84986 16.8284 8.6C17.5786 9.35015 18 10.3676 18 11.4284C18 12.4893 17.5786 13.5067 16.8284 14.2569C16.0783 15.007 15.0609 15.4284 14 15.4284C12.9391 15.4284 11.9217 15.007 11.1716 14.2569C10.4214 13.5067 10 12.4893 10 11.4284C10 10.3676 10.4214 9.35015 11.1716 8.6C11.9217 7.84986 12.9391 7.42843 14 7.42843ZM14 9.14272C13.3938 9.14272 12.8124 9.38353 12.3838 9.81219C11.9551 10.2408 11.7143 10.8222 11.7143 11.4284C11.7143 12.0346 11.9551 12.616 12.3838 13.0447C12.8124 13.4733 13.3938 13.7141 14 13.7141C14.6062 13.7141 15.1876 13.4733 15.6162 13.0447C16.0449 12.616 16.2857 12.0346 16.2857 11.4284C16.2857 10.8222 16.0449 10.2408 15.6162 9.81219C15.1876 9.38353 14.6062 9.14272 14 9.14272ZM21.4286 0.571289C22.4894 0.571289 23.5069 0.992717 24.257 1.74286C25.0071 2.49301 25.4286 3.51042 25.4286 4.57129C25.4286 5.63215 25.0071 6.64957 24.257 7.39972C23.5069 8.14986 22.4894 8.57129 21.4286 8.57129C20.3677 8.57129 19.3503 8.14986 18.6001 7.39972C17.85 6.64957 17.4286 5.63215 17.4286 4.57129C17.4286 3.51042 17.85 2.49301 18.6001 1.74286C19.3503 0.992717 20.3677 0.571289 21.4286 0.571289ZM6.57143 0.571289C7.63229 0.571289 8.64971 0.992717 9.39985 1.74286C10.15 2.49301 10.5714 3.51042 10.5714 4.57129C10.5714 5.63215 10.15 6.64957 9.39985 7.39972C8.64971 8.14986 7.63229 8.57129 6.57143 8.57129C5.51056 8.57129 4.49315 8.14986 3.743 7.39972C2.99285 6.64957 2.57143 5.63215 2.57143 4.57129C2.57143 3.51042 2.99285 2.49301 3.743 1.74286C4.49315 0.992717 5.51056 0.571289 6.57143 0.571289ZM21.4286 2.28557C20.8224 2.28557 20.241 2.52639 19.8123 2.95504C19.3837 3.3837 19.1429 3.96508 19.1429 4.57129C19.1429 5.1775 19.3837 5.75888 19.8123 6.18753C20.241 6.61619 20.8224 6.857 21.4286 6.857C22.0348 6.857 22.6162 6.61619 23.0448 6.18753C23.4735 5.75888 23.7143 5.1775 23.7143 4.57129C23.7143 3.96508 23.4735 3.3837 23.0448 2.95504C22.6162 2.52639 22.0348 2.28557 21.4286 2.28557ZM6.57143 2.28557C5.96522 2.28557 5.38384 2.52639 4.95518 2.95504C4.52653 3.3837 4.28571 3.96508 4.28571 4.57129C4.28571 5.1775 4.52653 5.75888 4.95518 6.18753C5.38384 6.61619 5.96522 6.857 6.57143 6.857C7.17764 6.857 7.75902 6.61619 8.18767 6.18753C8.61633 5.75888 8.85714 5.1775 8.85714 4.57129C8.85714 3.96508 8.61633 3.3837 8.18767 2.95504C7.75902 2.52639 7.17764 2.28557 6.57143 2.28557Z"
      fill="currentColor"
    />
  </svg>
);

export const locationHackSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M7.77601 14.3265C8.03776 15.1133 8.53426 15.141 8.88451 14.391L12.8663 5.85978C13.2165 5.10828 12.8918 4.78428 12.141 5.13453L3.60901 9.11553C2.85826 9.46578 2.88676 9.96228 3.67276 10.2248L6.75001 11.25L7.77601 14.3265Z"
      fill="#FDD649"
    />
  </svg>
);
// export const jobSvg = (
//   <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
//     <path
//       d="M28.4444 24.8891H3.55556V18.9513C2.89355 18.6342 2.29194 18.204 1.77778 17.6802V24.8891C1.77778 25.3606 1.96508 25.8127 2.29848 26.1461C2.63188 26.4795 3.08406 26.6668 3.55556 26.6668H28.4444C28.9159 26.6668 29.3681 26.4795 29.7015 26.1461C30.0349 25.8127 30.2222 25.3606 30.2222 24.8891V17.6802C29.7118 18.2061 29.1093 18.6339 28.4444 18.9424V24.8891Z"
//       fill="currentColor"
//     />
//     <path
//       d="M22.2222 19.9112C22.458 19.9112 22.6841 19.8175 22.8508 19.6508C23.0175 19.4841 23.1111 19.258 23.1111 19.0223V14.1689H21.3333V16.0001H12.4444V17.7778H21.3333V19.0223C21.3333 19.258 21.427 19.4841 21.5937 19.6508C21.7604 19.8175 21.9865 19.9112 22.2222 19.9112Z"
//       fill="currentColor"
//     />
//     <path
//       d="M29.3333 5.33356H21.3333V3.89356C21.324 3.32458 21.0895 2.7825 20.6814 2.386C20.2732 1.98949 19.7246 1.77087 19.1556 1.778H12.8444C12.2754 1.77087 11.7268 1.98949 11.3186 2.386C10.9105 2.7825 10.676 3.32458 10.6667 3.89356V5.33356H2.66667C2.43092 5.33356 2.20483 5.42721 2.03813 5.59391C1.87143 5.76061 1.77778 5.9867 1.77778 6.22245V13.3336C1.77778 14.5123 2.24603 15.6428 3.07953 16.4763C3.91302 17.3097 5.04348 17.778 6.22222 17.778H8.88889V19.0224C8.88889 19.2582 8.98254 19.4843 9.14924 19.651C9.31594 19.8177 9.54203 19.9113 9.77778 19.9113C10.0135 19.9113 10.2396 19.8177 10.4063 19.651C10.573 19.4843 10.6667 19.2582 10.6667 19.0224V14.1691H8.88889V16.0002H6.22222C5.51498 16.0002 4.8367 15.7193 4.33661 15.2192C3.83651 14.7191 3.55556 14.0408 3.55556 13.3336V7.11133H28.4444V13.3336C28.4444 14.0408 28.1635 14.7191 27.6634 15.2192C27.1633 15.7193 26.485 16.0002 25.7778 16.0002H24.8889V17.778H25.7778C26.9565 17.778 28.087 17.3097 28.9205 16.4763C29.754 15.6428 30.2222 14.5123 30.2222 13.3336V6.22245C30.2222 5.9867 30.1286 5.76061 29.9619 5.59391C29.7952 5.42721 29.5691 5.33356 29.3333 5.33356ZM19.5556 5.33356H12.4444V3.938C12.449 3.83503 12.4932 3.73779 12.5677 3.66658C12.6422 3.59537 12.7414 3.55568 12.8444 3.55578H19.1644C19.2146 3.5546 19.2646 3.56332 19.3114 3.58144C19.3582 3.59957 19.401 3.62674 19.4373 3.66141C19.4737 3.69608 19.5028 3.73757 19.5231 3.7835C19.5434 3.82943 19.5544 3.87891 19.5556 3.92911V5.33356Z"
//       fill="currentColor"
//     />
//   </svg>
// );
export const discordSvg = (
  <svg width="32" height="25" viewBox="0 0 32 25" fill="none">
    <path
      d="M27.0893 2.98914C25.0493 2.06914 22.8627 1.38914 20.576 1.00247C20.5556 0.998559 20.5346 1.00108 20.5157 1.00968C20.4968 1.01828 20.4811 1.03253 20.4707 1.05047C20.1907 1.54247 19.8787 2.1838 19.66 2.69047C17.2348 2.32812 14.7692 2.32812 12.344 2.69047C12.1004 2.12895 11.8258 1.58143 11.5213 1.05047C11.511 1.03231 11.4954 1.01774 11.4766 1.00868C11.4578 0.999629 11.4366 0.996531 11.416 0.999802C9.13067 1.38647 6.944 2.06647 4.90267 2.9878C4.88511 2.99517 4.87022 3.00773 4.86 3.0238C0.710667 9.1238 -0.426667 15.0731 0.132 20.9478C0.133555 20.9622 0.138021 20.9761 0.145127 20.9887C0.152232 21.0013 0.161829 21.0124 0.173333 21.0211C2.59519 22.7844 5.29645 24.1276 8.164 24.9945C8.18399 25.0006 8.20537 25.0006 8.22535 24.9944C8.24533 24.9882 8.26298 24.9762 8.276 24.9598C8.89306 24.1346 9.43986 23.2591 9.91067 22.3425C9.9172 22.3299 9.92097 22.3161 9.92171 22.302C9.92245 22.2879 9.92015 22.2738 9.91497 22.2607C9.90979 22.2475 9.90184 22.2356 9.89167 22.2258C9.88149 22.216 9.86933 22.2085 9.856 22.2038C8.99467 21.8794 8.16011 21.488 7.36 21.0331C7.34562 21.0249 7.33351 21.0133 7.32474 20.9992C7.31598 20.9852 7.31083 20.9692 7.30978 20.9527C7.30872 20.9362 7.31178 20.9196 7.31869 20.9046C7.32559 20.8895 7.33612 20.8764 7.34933 20.8665C7.51733 20.7425 7.68533 20.6131 7.84533 20.4838C7.85974 20.4722 7.87708 20.4648 7.89545 20.4624C7.91381 20.4601 7.93246 20.4628 7.94933 20.4705C13.1853 22.8225 18.856 22.8225 24.0307 20.4705C24.0476 20.4624 24.0664 20.4592 24.0851 20.4614C24.1037 20.4635 24.1213 20.4708 24.136 20.4825C24.296 20.6131 24.4627 20.7425 24.632 20.8665C24.6453 20.8762 24.656 20.8892 24.6632 20.9041C24.6703 20.919 24.6736 20.9354 24.6728 20.952C24.672 20.9685 24.6672 20.9845 24.6586 20.9987C24.6501 21.0129 24.6382 21.0247 24.624 21.0331C23.8267 21.4918 22.9973 21.8798 22.1267 22.2025C22.1133 22.2073 22.1011 22.215 22.0909 22.2249C22.0808 22.2348 22.0728 22.2468 22.0676 22.2601C22.0625 22.2733 22.0602 22.2875 22.0609 22.3017C22.0617 22.316 22.0655 22.3298 22.072 22.3425C22.552 23.2585 23.1013 24.1305 23.7053 24.9585C23.7179 24.9755 23.7354 24.9882 23.7554 24.9948C23.7755 25.0015 23.7971 25.0019 23.8173 24.9958C26.6898 24.1313 29.3955 22.7875 31.82 21.0211C31.8318 21.0129 31.8418 21.0022 31.8491 20.9897C31.8565 20.9773 31.8611 20.9635 31.8627 20.9491C32.5293 14.1571 30.7453 8.2558 27.1307 3.02647C27.1218 3.00947 27.1071 2.99623 27.0893 2.98914ZM10.6933 17.3705C9.11733 17.3705 7.81733 15.9451 7.81733 14.1971C7.81733 12.4478 9.092 11.0238 10.6933 11.0238C12.3067 11.0238 13.5947 12.4598 13.5693 14.1971C13.5693 15.9465 12.2947 17.3705 10.6933 17.3705ZM21.3267 17.3705C19.7493 17.3705 18.4507 15.9451 18.4507 14.1971C18.4507 12.4478 19.724 11.0238 21.3267 11.0238C22.94 11.0238 24.228 12.4598 24.2027 14.1971C24.2027 15.9465 22.9413 17.3705 21.3267 17.3705Z"
      fill="currentColor"
    />
  </svg>
);
// export const triBottomSvg = (
//   <svg width="14" height="11" viewBox="0 0 14 11" fill="none">
//     <path
//       d="M7.86602 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937821 1.5C0.552921 0.833333 1.03405 0 1.80385 0L12.1962 0C12.966 0 13.4471 0.833333 13.0622 1.5L7.86602 10.5Z"
//       fill="currentColor"
//     />
//   </svg>
// );
// export const profileSvg = (
//   <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M6.4045 16.357C9.827 15.857 12.1835 15.9 15.6105 16.3745C15.8587 16.4105 16.0855 16.535 16.249 16.7252C16.4125 16.9153 16.5016 17.1582 16.5 17.409C16.5 17.649 16.4175 17.882 16.2685 18.064C16.0088 18.3813 15.7427 18.6934 15.4705 19H16.791C16.874 18.901 16.9575 18.8 17.042 18.6975C17.3386 18.3338 18.0004 17.4693 18 17C18 15.9875 16.624 14.64 15.6105 14.5C12.1025 14.0145 9.247 13.9845 5.7195 14.5C4.6955 14.6495 4 15.9805 4 17C4 17.4525 4.6475 18.323 4.927 18.6855C5.0095 18.7925 5.091 18.8975 5.172 19.0005H6.4605C6.20721 18.6973 5.96016 18.3889 5.7195 18.0755C5.57648 17.8879 5.49933 17.6584 5.5 17.4225C5.5 16.884 5.887 16.4325 6.4045 16.357ZM11 11.5C11.394 11.5 11.7841 11.4224 12.148 11.2716C12.512 11.1209 12.8427 10.8999 13.1213 10.6213C13.3999 10.3427 13.6209 10.012 13.7716 9.64805C13.9224 9.28407 14 8.89397 14 8.5C14 8.10603 13.9224 7.71593 13.7716 7.35195C13.6209 6.98797 13.3999 6.65726 13.1213 6.37868C12.8427 6.1001 12.512 5.87913 12.148 5.72836C11.7841 5.5776 11.394 5.5 11 5.5C10.2044 5.5 9.44129 5.81607 8.87868 6.37868C8.31607 6.94129 8 7.70435 8 8.5C8 9.29565 8.31607 10.0587 8.87868 10.6213C9.44129 11.1839 10.2044 11.5 11 11.5ZM11 13C12.0609 13 13.6249 12.2501 14.375 11.5C15.1252 10.7499 15.6105 9.56087 15.6105 8.5C15.6105 7.43913 15.1252 6.25015 14.375 5.5C13.6249 4.74985 12.0609 4 11 4C9.93913 4 8.37515 4.62485 7.62501 5.375C6.87486 6.12514 6.4605 7.43913 6.4605 8.5C6.4605 9.56087 6.87486 10.9999 7.62501 11.75C8.37515 12.5001 9.93913 13 11 13Z"
//       fill="currentColor"
//     />
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M11 20C15.9705 20 20 15.9705 20 11C20 6.0295 15.9705 2 11 2C6.0295 2 2 6.0295 2 11C2 15.9705 6.0295 20 11 20ZM11 21.5C16.523 21.5 21.5 16.523 21.5 11C21.5 5.477 16.523 0.5 11 0.5C5.477 0.5 0.5 5.477 0.5 11C0.5 16.523 5.477 21.5 11 21.5Z"
//       fill="currentColor"
//     />
//   </svg>
// );
export const settingSvg = (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      d="M11.0666 6.3335C8.46657 6.3335 6.3999 8.40016 6.3999 11.0002C6.3999 13.6002 8.46657 15.6668 11.0666 15.6668C13.6666 15.6668 15.7332 13.6002 15.7332 11.0002C15.7332 8.40016 13.6666 6.3335 11.0666 6.3335ZM11.0666 14.3335C9.1999 14.3335 7.73324 12.8668 7.73324 11.0002C7.73324 9.1335 9.1999 7.66683 11.0666 7.66683C12.9332 7.66683 14.3999 9.1335 14.3999 11.0002C14.3999 12.8668 12.9332 14.3335 11.0666 14.3335Z"
      fill="currentColor"
    />
    <path
      d="M20.8666 8.80016L18.9999 8.20016L18.5999 7.20016L19.5333 5.46683C19.7333 5.06683 19.6666 4.5335 19.3333 4.20016L17.7333 2.60016C17.3999 2.26683 16.8666 2.20016 16.4666 2.40016L14.7333 3.3335L13.7333 2.9335L13.1333 1.06683C12.9999 0.666829 12.5999 0.333496 12.1333 0.333496H9.86658C9.39992 0.333496 8.99992 0.666829 8.93325 1.1335L8.33325 3.00016C7.93325 3.06683 7.59992 3.20016 7.26659 3.40016L5.53325 2.46683C5.13325 2.26683 4.59992 2.3335 4.26659 2.66683L2.66659 4.26683C2.33325 4.60016 2.26659 5.1335 2.46659 5.5335L3.33325 7.20016C3.19992 7.5335 3.06659 7.9335 2.93325 8.26683L1.06659 8.86683C0.666585 9.00016 0.333252 9.40016 0.333252 9.86683V12.1335C0.333252 12.6002 0.666585 13.0002 1.13325 13.1335L2.99992 13.7335L3.39992 14.7335L2.46659 16.4668C2.26659 16.8668 2.33325 17.4002 2.66659 17.7335L4.26659 19.3335C4.59992 19.6668 5.13325 19.7335 5.53325 19.5335L7.26659 18.6002L8.26659 19.0002L8.86659 20.9335C8.99992 21.3335 9.39992 21.6668 9.86658 21.6668H12.1333C12.5999 21.6668 12.9999 21.3335 13.1333 20.9335L13.7333 19.0002L14.7333 18.6002L16.4666 19.5335C16.8666 19.7335 17.3999 19.6668 17.7333 19.3335L19.3333 17.7335C19.6666 17.4002 19.7333 16.8668 19.5333 16.4668L18.5999 14.7335L18.9999 13.7335L20.9333 13.1335C21.3333 13.0002 21.6666 12.6002 21.6666 12.1335V9.86683C21.6666 9.40016 21.3333 8.9335 20.8666 8.80016ZM20.3333 11.9335L17.9333 12.6668L17.8666 13.0002L17.2666 14.4002L17.0666 14.7335L18.2666 16.9335L16.9333 18.2668L14.7333 17.0668L14.3999 17.2668C13.9333 17.5335 13.4666 17.7335 12.9999 17.8668L12.6666 17.9335L11.9333 20.3335H10.0666L9.33325 17.9335L8.99992 17.8668L7.59992 17.2668L7.26659 17.0668L5.06659 18.2668L3.73325 16.9335L4.93325 14.7335L4.73325 14.4002C4.46659 13.9335 4.26659 13.4668 4.13325 13.0002L4.06659 12.6668L1.66659 11.9335V10.0668L3.93325 9.40016L4.06659 9.06683C4.19992 8.5335 4.39992 8.06683 4.66659 7.60016L4.86659 7.26683L3.73325 5.06683L5.06659 3.7335L7.19992 4.9335L7.53325 4.7335C7.99992 4.46683 8.46659 4.26683 8.99992 4.1335L9.33325 4.00016L10.0666 1.66683H11.9333L12.6666 4.00016L12.9999 4.1335C13.4666 4.26683 13.9333 4.46683 14.3999 4.7335L14.7333 4.9335L16.9333 3.7335L18.2666 5.06683L17.0666 7.26683L17.2666 7.60016C17.5333 8.06683 17.7333 8.5335 17.8666 9.00016L17.9333 9.3335L20.3333 10.0668V11.9335Z"
      fill="currentColor"
    />
  </svg>
);
// export const signOutSvg = (
//   <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
//     <path
//       d="M19.0469 10.7969L15.1094 14.7344C15.0046 14.8388 14.8803 14.9215 14.7436 14.9778C14.6069 15.0341 14.4604 15.0629 14.3125 15.0625C14.0143 15.0612 13.7283 14.9435 13.5156 14.7344C13.4107 14.6299 13.3275 14.5057 13.2707 14.3689C13.214 14.2322 13.1847 14.0856 13.1847 13.9375C13.1847 13.7894 13.214 13.6428 13.2707 13.5061C13.3275 13.3693 13.4107 13.2451 13.5156 13.1406L15.5312 11.125H7.75C7.45163 11.125 7.16548 11.0065 6.9545 10.7955C6.74353 10.5845 6.625 10.2984 6.625 10C6.625 9.70163 6.74353 9.41548 6.9545 9.2045C7.16548 8.99353 7.45163 8.875 7.75 8.875H15.5312L13.5156 6.85938C13.3043 6.64803 13.1855 6.36139 13.1855 6.0625C13.1855 5.76361 13.3043 5.47697 13.5156 5.26562C13.727 5.05428 14.0136 4.93555 14.3125 4.93555C14.6114 4.93555 14.898 5.05428 15.1094 5.26562L19.0469 9.20312C19.1518 9.30764 19.235 9.43183 19.2918 9.56858C19.3485 9.70533 19.3778 9.85193 19.3778 10C19.3778 10.1481 19.3485 10.2947 19.2918 10.4314C19.235 10.5682 19.1518 10.6924 19.0469 10.7969ZM7.75 17.125H2.875V2.875H7.75C8.04837 2.875 8.33452 2.75647 8.5455 2.5455C8.75647 2.33452 8.875 2.04837 8.875 1.75C8.875 1.45163 8.75647 1.16548 8.5455 0.954505C8.33452 0.743526 8.04837 0.625 7.75 0.625H2.5C2.00348 0.627464 1.528 0.825799 1.1769 1.1769C0.825799 1.528 0.627464 2.00348 0.625 2.5V17.5C0.627464 17.9965 0.825799 18.472 1.1769 18.8231C1.528 19.1742 2.00348 19.3725 2.5 19.375H7.75C8.04837 19.375 8.33452 19.2565 8.5455 19.0455C8.75647 18.8345 8.875 18.5484 8.875 18.25C8.875 17.9516 8.75647 17.6655 8.5455 17.4545C8.33452 17.2435 8.04837 17.125 7.75 17.125Z"
//       fill="currentColor"
//     />
//   </svg>
// );

// export const questionsSvg = (
//   <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M19.9998 5.33317V14.6665H6.89317L6.1065 15.4532L5.33317 16.2265V5.33317H19.9998ZM21.3332 2.6665H3.99984C3.2665 2.6665 2.6665 3.2665 2.6665 3.99984V22.6665L7.99984 17.3332H21.3332C22.0665 17.3332 22.6665 16.7332 22.6665 15.9998V3.99984C22.6665 3.2665 22.0665 2.6665 21.3332 2.6665ZM27.9998 7.99984H25.3332V19.9998H7.99984V22.6665C7.99984 23.3998 8.59984 23.9998 9.33317 23.9998H23.9998L29.3332 29.3332V9.33317C29.3332 8.59984 28.7332 7.99984 27.9998 7.99984Z" fill="currentColor"
//     />
//   </svg>
// );

// export const projectsSvg = (
//   <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path fillRule="evenodd" clipRule="evenodd" d="M21.14 2.28L27.7 8.88L28 9.6V29L27 30H5L4 29V3L5 2H20.44L21.14 2.28V2.28ZM20 10H26L20 4V10ZM6 4V28H26V12H19L18 11V4H6ZM10.124 19.066L13.758 15.41L12.34 14L8 18.358V19.772L12.342 24.12L13.756 22.706L10.124 19.066V19.066ZM17.6 15.428L19 14.01L23.378 18.36V19.778L19 24.124L17.59 22.706L21.252 19.066L17.6 15.428Z" fill="currentColor" />
//   </svg>
// );

// export const feedSvg = (
//   <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M26.4998 4H5.49984C3.93717 4 2.6665 5.196 2.6665 6.66667V25.3333C2.6665 26.804 3.93717 28 5.49984 28H26.4998C28.0625 28 29.3332 26.804 29.3332 25.3333V6.66667C29.3332 5.196 28.0625 4 26.4998 4ZM26.4998 25.3333H5.49984C5.42384 25.3333 5.37184 25.312 5.34917 25.312C5.33984 25.312 5.3345 25.3147 5.33317 25.3227L5.31717 6.728C5.3265 6.71467 5.3865 6.66667 5.49984 6.66667H26.4998C26.6052 6.668 26.6625 6.704 26.6665 6.67733L26.6825 25.272C26.6732 25.2853 26.6132 25.3333 26.4998 25.3333Z" fill="black" />
//     <path d="M8 9.3335H16V17.3335H8V9.3335ZM17.3333 20.0002H8V22.6668H24V20.0002H18.6667H17.3333ZM18.6667 14.6668H24V17.3335H18.6667V14.6668ZM18.6667 9.3335H24V12.0002H18.6667V9.3335Z" fill="currentColor" />
//   </svg>
// );

// export const chevronRightSvg = (
//   <svg width="10" height="14" viewBox="0 0 10 14" fill="none">
//     <path
//       d="M2.36617 0L0 2.27838L4.53449 7.00377L0 11.7216L2.36617 14L7.99242 8.13932L9.08393 7.00381L7.99242 5.86094L2.36617 0Z"
//       fill="currentColor"
//     />
//   </svg>
// );

// export const stackUp = (
//   <svg aria-hidden="true" width="36" height="36" viewBox="0 0 36 36">
//     <path d="M2 25h32L18 9 2 25Z" fill="currentColor"></path>
//   </svg>
// );
// export const stackDown = (
//   <svg aria-hidden="true" width="36" height="36" viewBox="0 0 36 36">
//     <path d="M2 11h32L18 27 2 11Z" fill="currentColor"></path>
//   </svg>
// );
// export const stackMark = (
//   <svg aria-hidden="true" width="18" height="18" viewBox="0 0 18 18">
//     <path
//       fill="currentColor"
//       d="M6 1a2 2 0 0 0-2 2v14l5-4 5 4V3a2 2 0 0 0-2-2H6Zm3.9 3.83h2.9l-2.35 1.7.9 2.77L9 7.59l-2.35 1.7.9-2.76-2.35-1.7h2.9L9 2.06l.9 2.77Z"
//     ></path>
//   </svg>
// );
// export const stackHistory = (
//   <svg aria-hidden="true" width="19" height="18" viewBox="0 0 19 18">
//     <path
//       fill="currentColor"
//       d="M3 9a8 8 0 1 1 3.73 6.77L8.2 14.3A6 6 0 1 0 5 9l3.01-.01-4 4-4-4h3L3 9Zm7-4h1.01L11 9.36l3.22 2.1-.6.93L10 10V5Z"
//     ></path>
//   </svg>
// );
export const dashboardSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 19.77V15.73C22 14.14 21.36 13.5 19.77 13.5H15.73C14.14 13.5 13.5 14.14 13.5 15.73V19.77C13.5 21.36 14.14 22 15.73 22H19.77C21.36 22 22 21.36 22 19.77Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const projectsSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13L8 15L10 17"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 13L16 15L14 17"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const questionSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8.5 18.97H8C4 18.97 2 17.97 2 12.97V7.96997C2 3.96997 4 1.96997 8 1.96997H16C20 1.96997 22 3.96997 22 7.96997V12.97C22 16.97 20 18.97 16 18.97H15.5C15.19 18.97 14.89 19.12 14.7 19.37L13.2 21.37C12.54 22.25 11.46 22.25 10.8 21.37L9.29999 19.37C9.13999 19.15 8.78 18.97 8.5 18.97Z"
      stroke="#FACC14"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8.70052L6 10.7005L8 12.7005"
      stroke="#FACC14"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 8.70052L18 10.7005L16 12.7005"
      stroke="#FACC14"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 8.37L11 13.03"
      stroke="#FACC14"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const questionsSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 18.9697H8C4 18.9697 2 17.9697 2 12.9697V7.96973C2 3.96973 4 1.96973 8 1.96973H16C20 1.96973 22 3.96973 22 7.96973V12.9697C22 16.9697 20 18.9697 16 18.9697H15.5C15.19 18.9697 14.89 19.1198 14.7 19.3698L13.2 21.3698C12.54 22.2498 11.46 22.2498 10.8 21.3698L9.29999 19.3698C9.13999 19.1498 8.78 18.9697 8.5 18.9697Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8.7002L6 10.7002L8 12.7002"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 8.7002L18 10.7002L16 12.7002"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 8.37012L11 13.0302"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const challengeSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1504 16.5V18.6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.15039 22H17.1504V21C17.1504 19.9 16.2504 19 15.1504 19H9.15039C8.05039 19 7.15039 19.9 7.15039 21V22V22Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M6.15039 22H18.1504"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16C8.13 16 5 12.87 5 9V6C5 3.79 6.79 2 9 2H15C17.21 2 19 3.79 19 6V9C19 12.87 15.87 16 12 16Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.46906 11.6501C4.71906 11.4101 4.05906 10.9701 3.53906 10.4501C2.63906 9.4501 2.03906 8.2501 2.03906 6.8501C2.03906 5.4501 3.13906 4.3501 4.53906 4.3501H5.18906C4.98906 4.8101 4.88906 5.3201 4.88906 5.8501V8.8501C4.88906 9.8501 5.09906 10.7901 5.46906 11.6501Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5312 11.6501C19.2812 11.4101 19.9412 10.9701 20.4612 10.4501C21.3612 9.4501 21.9612 8.2501 21.9612 6.8501C21.9612 5.4501 20.8612 4.3501 19.4612 4.3501H18.8112C19.0112 4.8101 19.1112 5.3201 19.1112 5.8501V8.8501C19.1112 9.8501 18.9013 10.7901 18.5312 11.6501Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const learnSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M16.5 12.555V3.50252C16.5 2.60252 15.765 1.93502 14.8725 2.01002H14.8275C13.2525 2.14502 10.86 2.94752 9.525 3.78752L9.3975 3.87002C9.18 4.00502 8.82 4.00502 8.6025 3.87002L8.415 3.75752C7.08 2.92502 4.695 2.13002 3.12 2.00252C2.2275 1.92752 1.5 2.60252 1.5 3.49502V12.555C1.5 13.275 2.085 13.95 2.805 14.04L3.0225 14.07C4.65 14.2875 7.1625 15.1125 8.6025 15.9L8.6325 15.915C8.835 16.0275 9.1575 16.0275 9.3525 15.915C10.7925 15.12 13.3125 14.2875 14.9475 14.07L15.195 14.04C15.915 13.95 16.5 13.275 16.5 12.555Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 4.11749V15.3675"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.8125 6.36749H4.125"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.375 8.61749H4.125"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const jobsSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.0008 22H16.0008C20.0208 22 20.7408 20.39 20.9508 18.43L21.7008 10.43C21.9708 7.99 21.2708 6 17.0008 6H7.0008C2.7308 6 2.0308 7.99 2.3008 10.43L3.0508 18.43C3.2608 20.39 3.9808 22 8.0008 22Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 6V5.2C8 3.43 8 2 11.2 2H12.8C16 2 16 3.43 16 5.2V6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 13V14C14 14.01 14 14.01 14 14.02C14 15.11 13.99 16 12 16C10.02 16 10 15.12 10 14.03V13C10 12 10 12 11 12H13C14 12 14 12 14 13Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.65 11C19.34 12.68 16.7 13.68 14 14.02"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.61914 11.27C4.86914 12.81 7.40914 13.74 9.99914 14.03"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const exploreSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.7991 2.1L7.86912 4.59C6.41912 4.95 4.94912 6.42 4.58912 7.87L2.09912 17.8C1.34912 20.8 3.18912 22.65 6.19912 21.9L16.1291 19.42C17.5691 19.06 19.0491 17.58 19.4091 16.14L21.8991 6.2C22.6491 3.2 20.7991 1.35 17.7991 2.1Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const aiInternshipSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.19495 8.26496V11.9925C3.19495 13.3575 3.19495 13.3575 4.48495 14.2275L8.03245 16.275C8.56495 16.5825 9.43495 16.5825 9.96745 16.275L13.5149 14.2275C14.8049 13.3575 14.8049 13.3575 14.8049 11.9925V8.26496C14.8049 6.89996 14.8049 6.89996 13.5149 6.02996L9.96745 3.98246C9.43495 3.67496 8.56495 3.67496 8.03245 3.98246L4.48495 6.02996C3.19495 6.89996 3.19495 6.89996 3.19495 8.26496Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.125 5.7225V3.75C13.125 2.25 12.375 1.5 10.875 1.5H7.125C5.625 1.5 4.875 2.25 4.875 3.75V5.67"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.47246 8.24247L9.89996 8.90997C9.96746 9.01497 10.1175 9.11997 10.23 9.14997L10.995 9.34497C11.4675 9.46497 11.595 9.86997 11.2875 10.245L10.785 10.8525C10.71 10.95 10.65 11.1225 10.6575 11.2425L10.7025 12.03C10.7325 12.5175 10.3875 12.765 9.93746 12.585L9.20246 12.2925C9.08996 12.2475 8.90246 12.2475 8.78996 12.2925L8.05496 12.585C7.60496 12.765 7.25996 12.51 7.28996 12.03L7.33496 11.2425C7.34246 11.1225 7.28246 10.9425 7.20746 10.8525L6.70496 10.245C6.39746 9.86997 6.52496 9.46497 6.99746 9.34497L7.76246 9.14997C7.88246 9.11997 8.03246 9.00747 8.09246 8.90997L8.51996 8.24247C8.78996 7.83747 9.20996 7.83747 9.47246 8.24247Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const profileSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5901 22C20.5901 18.13 16.7402 15 12.0002 15C7.26015 15 3.41016 18.13 3.41016 22"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const helpSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 18.4302H13L8.54999 21.3902C7.88999 21.8302 7 21.3602 7 20.5602V18.4302C4 18.4302 2 16.4302 2 13.4302V7.43018C2 4.43018 4 2.43018 7 2.43018H17C20 2.43018 22 4.43018 22 7.43018V13.4302C22 16.4302 20 18.4302 17 18.4302Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9998 11.3599V11.1499C11.9998 10.4699 12.4198 10.1099 12.8398 9.81989C13.2498 9.53989 13.6598 9.1799 13.6598 8.5199C13.6598 7.5999 12.9198 6.85986 11.9998 6.85986C11.0798 6.85986 10.3398 7.5999 10.3398 8.5199"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9955 13.75H12.0045"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const logoutSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.90039 7.56023C9.21039 3.96023 11.0604 2.49023 15.1104 2.49023H15.2404C19.7104 2.49023 21.5004 4.28023 21.5004 8.75023V15.2702C21.5004 19.7402 19.7104 21.5302 15.2404 21.5302H15.1104C11.0904 21.5302 9.24039 20.0802 8.91039 16.5402"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.9991 12H3.61914"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.85 8.6499L2.5 11.9999L5.85 15.3499"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const caretDownSvg = (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.1637 12.4902L19.202 21.452C18.1436 22.5104 16.4117 22.5104 15.3534 21.452L6.3916 12.4902"
      stroke="currentColor"
      strokeWidth="2.06175"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const caretUpSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9201 15.0501L13.4001 8.53014C12.6301 7.76014 11.3701 7.76014 10.6001 8.53014L4.08008 15.0501"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const resourcesSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2451 10.8299L18.5101 13.9649C17.8801 16.6724 16.6351 17.7674 14.2951 17.5424C13.9201 17.5124 13.5151 17.4449 13.0801 17.3399L11.8201 17.0399C8.69263 16.2974 7.72513 14.7524 8.46013 11.6174L9.19513 8.47488C9.34513 7.83738 9.52513 7.28238 9.75013 6.82488C10.6276 5.00988 12.1201 4.52238 14.6251 5.11488L15.8776 5.40738C19.0201 6.14238 19.9801 7.69488 19.2451 10.8299Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.2957 17.5427C13.8307 17.8577 13.2457 18.1202 12.5332 18.3527L11.3482 18.7427C8.37074 19.7027 6.80324 18.9002 5.83574 15.9227L4.87574 12.9602C3.91574 9.9827 4.71074 8.4077 7.68824 7.4477L8.87324 7.0577C9.18074 6.9602 9.47324 6.8777 9.75074 6.8252C9.52574 7.2827 9.34574 7.8377 9.19574 8.4752L8.46074 11.6177C7.72574 14.7527 8.69324 16.2977 11.8207 17.0402L13.0807 17.3402C13.5157 17.4452 13.9207 17.5127 14.2957 17.5427Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="0.5"
      y="0.5"
      width="23"
      height="23"
      rx="11.5"
      stroke="currentColor"
    />
  </svg>
);
export const hamburgerSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 7H21"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3 12H21"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3 17H21"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
export const tutorialSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.82422 11.9996V10.8896C9.82422 9.45713 10.8367 8.87963 12.0742 9.59213L13.0342 10.1471L13.9942 10.7021C15.2317 11.4146 15.2317 12.5846 13.9942 13.2971L13.0342 13.8521L12.0742 14.4071C10.8367 15.1196 9.82422 14.5346 9.82422 13.1096V11.9996Z"
      stroke="#747474"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5Z"
      stroke="#747474"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#747474" />
  </svg>
);
export const troubleshootSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0627 4.83773C11.5877 4.39523 12.4352 4.39523 12.9452 4.83773L14.1302 5.85023C14.3552 6.03773 14.7827 6.19523 15.0827 6.19523H16.3577C17.1527 6.19523 17.8052 6.84773 17.8052 7.64273V8.91773C17.8052 9.21773 17.9627 9.63773 18.1502 9.86273L19.1627 11.0477C19.6052 11.5727 19.6052 12.4202 19.1627 12.9302L18.1502 14.1152C17.9627 14.3402 17.8052 14.7602 17.8052 15.0602V16.3352C17.8052 17.1302 17.1527 17.7827 16.3577 17.7827H15.0827C14.7827 17.7827 14.3627 17.9402 14.1377 18.1277L12.9527 19.1402C12.4277 19.5827 11.5802 19.5827 11.0702 19.1402L9.88516 18.1277C9.66016 17.9402 9.23266 17.7827 8.94016 17.7827H7.62766C6.83266 17.7827 6.18016 17.1302 6.18016 16.3352V15.0527C6.18016 14.7602 6.03016 14.3327 5.84266 14.1152L4.83016 12.9227C4.39516 12.4052 4.39516 11.5652 4.83016 11.0477L5.84266 9.85523C6.03016 9.63023 6.18016 9.21023 6.18016 8.91773V7.65023C6.18016 6.85523 6.83266 6.20273 7.62766 6.20273H8.92516C9.22516 6.20273 9.64516 6.04523 9.87016 5.85773L11.0627 4.83773Z"
      stroke="#747474"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 9.09766V12.7202"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9961 15H12.0028"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="0.5"
      y="0.5"
      width="23"
      height="23"
      rx="11.5"
      stroke="currentColor"
    />
  </svg>
);
export const closeSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5304 5.53033C19.8232 5.23744 19.8232 4.76256 19.5304 4.46967C19.2375 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9394L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76257 4.17678 5.23744 4.46967 5.53033L10.9394 12L4.4697 18.4697C4.1768 18.7626 4.1768 19.2374 4.4697 19.5303C4.76259 19.8232 5.23746 19.8232 5.53036 19.5303L12 13.0607L18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5304 5.53033Z"
      fill="currentColor"
    />
  </svg>
);

export const ellipsisSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="4"
    viewBox="0 0 4 4"
    fill="none"
  >
    <circle cx="2" cy="2" r="2" fill="#888888" />
  </svg>
);

export const challengeIconSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8.09961 11V12.4"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.76758 14.6665H11.4342V13.9998C11.4342 13.2665 10.8342 12.6665 10.1009 12.6665H6.10091C5.36758 12.6665 4.76758 13.2665 4.76758 13.9998V14.6665V14.6665Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M4.09961 14.6665H12.0996"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00065 10.6668C5.42065 10.6668 3.33398 8.58016 3.33398 6.00016V4.00016C3.33398 2.52683 4.52732 1.3335 6.00065 1.3335H10.0007C11.474 1.3335 12.6673 2.52683 12.6673 4.00016V6.00016C12.6673 8.58016 10.5807 10.6668 8.00065 10.6668Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.64604 7.76657C3.14604 7.60657 2.70604 7.31324 2.35938 6.96657C1.75938 6.2999 1.35938 5.4999 1.35938 4.56657C1.35938 3.63324 2.09271 2.8999 3.02604 2.8999H3.45938C3.32604 3.20657 3.25937 3.54657 3.25937 3.8999V5.8999C3.25937 6.56657 3.39937 7.19324 3.64604 7.76657Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3535 7.76657C12.8535 7.60657 13.2935 7.31324 13.6402 6.96657C14.2402 6.2999 14.6402 5.4999 14.6402 4.56657C14.6402 3.63324 13.9068 2.8999 12.9735 2.8999H12.5402C12.6735 3.20657 12.7402 3.54657 12.7402 3.8999V5.8999C12.7402 6.56657 12.6002 7.19324 12.3535 7.76657Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const notificationBellSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0201 2.90991C8.71009 2.90991 6.02009 5.59991 6.02009 8.90991V11.7999C6.02009 12.4099 5.76009 13.3399 5.45009 13.8599L4.30009 15.7699C3.59009 16.9499 4.08009 18.2599 5.38009 18.6999C9.69009 20.1399 14.3401 20.1399 18.6501 18.6999C19.8601 18.2999 20.3901 16.8699 19.7301 15.7699L18.5801 13.8599C18.2801 13.3399 18.0201 12.4099 18.0201 11.7999V8.90991C18.0201 5.60991 15.3201 2.90991 12.0201 2.90991Z"
      stroke="#FACC14"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M13.8699 3.19994C13.5599 3.10994 13.2399 3.03994 12.9099 2.99994C11.9499 2.87994 11.0299 2.94994 10.1699 3.19994C10.4599 2.45994 11.1799 1.93994 12.0199 1.93994C12.8599 1.93994 13.5799 2.45994 13.8699 3.19994Z"
      stroke="#FACC14"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.02 19.0601C15.02 20.7101 13.67 22.0601 12.02 22.0601C11.2 22.0601 10.44 21.7201 9.90002 21.1801C9.36002 20.6401 9.02002 19.8801 9.02002 19.0601"
      stroke="#FACC14"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);
export const profile2UserSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16006 10.87C9.06006 10.86 8.94006 10.86 8.83006 10.87C6.45006 10.79 4.56006 8.84 4.56006 6.44C4.56006 3.99 6.54006 2 9.00006 2C11.4501 2 13.4401 3.99 13.4401 6.44C13.4301 8.84 11.5401 10.79 9.16006 10.87Z"
      stroke="#FACC14"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4098 4C18.3498 4 19.9098 5.57 19.9098 7.5C19.9098 9.39 18.4098 10.93 16.5398 11C16.4598 10.99 16.3698 10.99 16.2798 11"
      stroke="#FACC14"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16021 14.56C1.74021 16.18 1.74021 18.82 4.16021 20.43C6.91021 22.27 11.4202 22.27 14.1702 20.43C16.5902 18.81 16.5902 16.17 14.1702 14.56C11.4302 12.73 6.92021 12.73 4.16021 14.56Z"
      stroke="#FACC14"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3398 20C19.0598 19.85 19.7398 19.56 20.2998 19.13C21.8598 17.96 21.8598 16.03 20.2998 14.86C19.7498 14.44 19.0798 14.16 18.3698 14"
      stroke="#FACC14"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const streetcredActivity = (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 22H15.5C20.5 22 22.5 20 22.5 15V9C22.5 4 20.5 2 15.5 2H9.5C4.5 2 2.5 4 2.5 9V15C2.5 20 4.5 22 9.5 22Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.83008 14.4898L10.2101 11.3998C10.5501 10.9598 11.1801 10.8798 11.6201 11.2198L13.4501 12.6598C13.8901 12.9998 14.5201 12.9198 14.8601 12.4898L17.1701 9.50977"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RefreshBtn = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 12C22 17.52 17.52 22 12 22C6.48 22 3.11 16.44 3.11 16.44M3.11 16.44H7.63M3.11 16.44V21.44M2 12C2 6.48 6.44 2 12 2C18.67 2 22 7.56 22 7.56M22 7.56V2.56M22 7.56H17.56"
      stroke="#FDD649"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RefreshSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 9C16.5 13.14 13.14 16.5 9 16.5C4.86 16.5 2.3325 12.33 2.3325 12.33M2.3325 12.33H5.7225M2.3325 12.33V16.08M1.5 9C1.5 4.86 4.83 1.5 9 1.5C14.0025 1.5 16.5 5.67 16.5 5.67M16.5 5.67V1.92M16.5 5.67H13.17"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const linearRefreshSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9125 16.2525C14.13 15.405 16.5 12.48 16.5 9C16.5 4.86 13.17 1.5 9 1.5C3.9975 1.5 1.5 5.67 1.5 5.67M1.5 5.67V2.25M1.5 5.67H3.0075H4.83"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 9C1.5 13.14 4.86 16.5 9 16.5"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="3 3"
    />
  </svg>
);

export const layerSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0095 2.92031L18.9095 5.54031C20.6095 6.29031 20.6095 7.53031 18.9095 8.28031L13.0095 10.9003C12.3395 11.2003 11.2395 11.2003 10.5695 10.9003L4.66953 8.28031C2.96953 7.53031 2.96953 6.29031 4.66953 5.54031L10.5695 2.92031C11.2395 2.62031 12.3395 2.62031 13.0095 2.92031Z"
      stroke="#5F5F5F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 11C3 11.84 3.63 12.81 4.4 13.15L11.19 16.17C11.71 16.4 12.3 16.4 12.81 16.17L19.6 13.15C20.37 12.81 21 11.84 21 11"
      stroke="#5F5F5F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 16C3 16.93 3.55 17.77 4.4 18.15L11.19 21.17C11.71 21.4 12.3 21.4 12.81 21.17L19.6 18.15C20.45 17.77 21 16.93 21 16"
      stroke="#5F5F5F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const locationSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0009 13.4295C13.724 13.4295 15.1209 12.0326 15.1209 10.3095C15.1209 8.58633 13.724 7.18945 12.0009 7.18945C10.2777 7.18945 8.88086 8.58633 8.88086 10.3095C8.88086 12.0326 10.2777 13.4295 12.0009 13.4295Z"
      stroke="#5F5F5F"
      strokeWidth="1.5"
    />
    <path
      d="M3.61971 8.49C5.58971 -0.169998 18.4197 -0.159997 20.3797 8.5C21.5297 13.58 18.3697 17.88 15.5997 20.54C13.5897 22.48 10.4097 22.48 8.38971 20.54C5.62971 17.88 2.46971 13.57 3.61971 8.49Z"
      stroke="#5F5F5F"
      strokeWidth="1.5"
    />
  </svg>
);

export const locationPinSvg = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.99994 6.71521C6.86151 6.71521 7.55994 6.01678 7.55994 5.15521C7.55994 4.29365 6.86151 3.59521 5.99994 3.59521C5.13838 3.59521 4.43994 4.29365 4.43994 5.15521C4.43994 6.01678 5.13838 6.71521 5.99994 6.71521Z"
      stroke="currentColor"
    />
    <path
      d="M1.80998 4.245C2.79498 -0.0849988 9.20998 -0.0799987 10.19 4.25C10.765 6.79 9.18498 8.94 7.79998 10.27C6.79498 11.24 5.20498 11.24 4.19498 10.27C2.81498 8.94 1.23498 6.785 1.80998 4.245Z"
      stroke="currentColor"
    />
  </svg>
);

export const moneysSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.3009 7.91949V13.0695C19.3009 16.1495 17.5409 17.4695 14.9009 17.4695H6.11093C5.66093 17.4695 5.23093 17.4295 4.83093 17.3395C4.58093 17.2995 4.34094 17.2295 4.12094 17.1495C2.62094 16.5895 1.71094 15.2895 1.71094 13.0695V7.91949C1.71094 4.83949 3.47093 3.51953 6.11093 3.51953H14.9009C17.1409 3.51953 18.7509 4.46953 19.1809 6.63953C19.2509 7.03953 19.3009 7.44949 19.3009 7.91949Z"
      stroke="#5F5F5F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.302 10.9196V16.0696C22.302 19.1496 20.542 20.4696 17.902 20.4696H9.11203C8.37203 20.4696 7.70204 20.3697 7.12204 20.1497C5.93204 19.7097 5.12203 18.7997 4.83203 17.3397C5.23203 17.4297 5.66203 17.4696 6.11203 17.4696H14.902C17.542 17.4696 19.302 16.1496 19.302 13.0696V7.91962C19.302 7.44962 19.262 7.02965 19.182 6.63965C21.082 7.03965 22.302 8.37962 22.302 10.9196Z"
      stroke="#5F5F5F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4994 13.1394C11.9574 13.1394 13.1394 11.9574 13.1394 10.4994C13.1394 9.04136 11.9574 7.85938 10.4994 7.85938C9.04136 7.85938 7.85938 9.04136 7.85938 10.4994C7.85938 11.9574 9.04136 13.1394 10.4994 13.1394Z"
      stroke="#5F5F5F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.78125 8.29883V12.6989"
      stroke="#5F5F5F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2227 8.2998V12.6998"
      stroke="#5F5F5F"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const userTickSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
      stroke="#FEE38B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.41 22C3.41 18.13 7.26 15 12 15C12.96 15 13.89 15.13 14.76 15.37"
      stroke="#FEE38B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 18C22 18.75 21.79 19.46 21.42 20.06C21.21 20.42 20.94 20.74 20.63 21C19.93 21.63 19.01 22 18 22C16.54 22 15.27 21.22 14.58 20.06C14.21 19.46 14 18.75 14 18C14 16.74 14.58 15.61 15.5 14.88C16.19 14.33 17.06 14 18 14C20.21 14 22 15.79 22 18Z"
      stroke="#FEE38B"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.44 18L17.43 18.99L19.56 17.02"
      stroke="#FEE38B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const exportSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.44 8.90002C20.04 9.21002 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24002 7.46998 8.91002"
      stroke="#121212"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15V3.62"
      stroke="#121212"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.35 5.85L12 2.5L8.65002 5.85"
      stroke="#121212"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const sendSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.50978 4.22965L18.0698 8.50965C21.9098 10.4296 21.9098 13.5696 18.0698 15.4896L9.50978 19.7696C3.74978 22.6496 1.39978 20.2896 4.27978 14.5396L5.14978 12.8096C5.36978 12.3696 5.36978 11.6396 5.14978 11.1996L4.27978 9.45965C1.39978 3.70965 3.75978 1.34965 9.50978 4.22965Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.43994 12H10.8399"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const copySvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 6.9V11.1C22 14.6 20.6 16 17.1 16H16V12.9C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2H17.1C20.6 2 22 3.4 22 6.9Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const microphoneSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 11.625C10.6575 11.625 12 10.2825 12 8.625V4.5C12 2.8425 10.6575 1.5 9 1.5C7.3425 1.5 6 2.8425 6 4.5V8.625C6 10.2825 7.3425 11.625 9 11.625Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.26245 7.2373V8.51231C3.26245 11.6773 5.83495 14.2498 8.99995 14.2498C12.165 14.2498 14.7375 11.6773 14.7375 8.51231V7.2373"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.95752 4.82234C8.63252 4.57484 9.36752 4.57484 10.0425 4.82234"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.3999 6.41273C8.7974 6.30773 9.2099 6.30773 9.6074 6.41273"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 14.25V16.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const syncSvg = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9584 8.74414L9.03589 11.6725"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.04175 8.74414H11.9584"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.04175 5.25597L4.96425 2.32764"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9584 5.25586H2.04175"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TextSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.00244 5.37746V4.01246C2.00244 3.14996 2.69994 2.45996 3.55494 2.45996H14.4449C15.3074 2.45996 15.9974 3.15746 15.9974 4.01246V5.37746"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 15.54V3.08252"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.04492 15.54H11.9549"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const exportBtnSvg = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.60156 4.60417L8.4149 2.79083L10.2282 4.60417"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.41504 10.0442V2.84042"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.83325 8.5C2.83325 11.6308 4.95825 14.1667 8.49992 14.1667C12.0416 14.1667 14.1666 11.6308 14.1666 8.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const searchIconSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.25 15C11.9779 15 15 11.9779 15 8.25C15 4.52208 11.9779 1.5 8.25 1.5C4.52208 1.5 1.5 4.52208 1.5 8.25C1.5 11.9779 4.52208 15 8.25 15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1973 15.5174C14.5948 16.7174 15.5023 16.8374 16.1998 15.7874C16.8373 14.8274 16.4173 14.0399 15.2623 14.0399C14.4073 14.0324 13.9273 14.6999 14.1973 15.5174Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const bookSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 16.7399V4.66994C22 3.46994 21.02 2.57994 19.83 2.67994H19.77C17.67 2.85994 14.48 3.92994 12.7 5.04994L12.53 5.15994C12.24 5.33994 11.76 5.33994 11.47 5.15994L11.22 5.00994C9.44 3.89994 6.26 2.83994 4.16 2.66994C2.97 2.56994 2 3.46994 2 4.65994V16.7399C2 17.6999 2.78 18.5999 3.74 18.7199L4.03 18.7599C6.2 19.0499 9.55 20.1499 11.47 21.1999L11.51 21.2199C11.78 21.3699 12.21 21.3699 12.47 21.2199C14.39 20.1599 17.75 19.0499 19.93 18.7599L20.26 18.7199C21.22 18.5999 22 17.6999 22 16.7399Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5.48999V20.49"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.75 8.48999H5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 11.49H5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const codeCircleSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 10L6 12L8 14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 10L18 12L16 14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 9.66992L11 14.33"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const smallArrowRightSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M9.62012 3.95312L13.6668 7.99979L9.62012 12.0465"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.33301 8H13.553"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowRightSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.43 5.92999L20.5 12L14.43 18.07"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 12H20.33"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowLeftSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2499 14.9401L6.35988 10.0501C5.78238 9.47256 5.78238 8.52756 6.35988 7.95006L11.2499 3.06006"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowUpSvg = (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.28484 4.785L6.24984 1.75L3.21484 4.785"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 10.25V1.83496"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowDownSvg = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.03484 7.21509L5.99984 10.2501L2.96484 7.21509"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 1.75V10.165"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const moreHorizSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
      stroke="#FDD649"
      strokeWidth="1.5"
    />
  </svg>
);
export const userOutlinedSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 9C11.0711 9 12.75 7.32107 12.75 5.25C12.75 3.17893 11.0711 1.5 9 1.5C6.92893 1.5 5.25 3.17893 5.25 5.25C5.25 7.32107 6.92893 9 9 9Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4426 16.5C15.4426 13.5975 12.5551 11.25 9.00011 11.25C5.44511 11.25 2.55762 13.5975 2.55762 16.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UnionLineSvg = ({ active }) => {
  return active ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="73"
      height="8"
      viewBox="0 0 73 8"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69 8C71.2091 8 73 6.20914 73 4C73 1.79086 71.2091 0 69 0C67.5194 0 66.2267 0.804397 65.5351 2H0V6H65.5351C66.2267 7.1956 67.5194 8 69 8Z"
        fill="url(#paint0_linear_6506_6149)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6506_6149"
          x1="0"
          y1="0"
          x2="7.66482"
          y2="24.2946"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBDA61" />
          <stop offset="1" stopColor="#FF5ACD" />
        </linearGradient>
      </defs>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="73"
      height="8"
      viewBox="0 0 73 8"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69 8C71.2091 8 73 6.20914 73 4C73 1.79086 71.2091 0 69 0C67.5194 0 66.2267 0.804397 65.5351 2H0V6H65.5351C66.2267 7.1956 67.5194 8 69 8Z"
        fill="#292929"
      />
    </svg>
  );
};

export const ChatSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12.015C2 6.74712 6.21 2 12.02 2C17.7 2 22 6.65699 22 11.985C22 18.1642 16.96 22 12 22C10.36 22 8.54 21.5593 7.08 20.698C6.57 20.3876 6.14 20.1572 5.59 20.3375L3.57 20.9384C3.06 21.0986 2.6 20.698 2.75 20.1572L3.42 17.9139C3.53 17.6034 3.51 17.2729 3.35 17.0125C2.49 15.4301 2 13.6975 2 12.015ZM10.7 12.015C10.7 12.7261 11.27 13.2969 11.98 13.307C12.69 13.307 13.26 12.7261 13.26 12.025C13.26 11.314 12.69 10.7431 11.98 10.7431C11.28 10.7331 10.7 11.314 10.7 12.015ZM15.31 12.025C15.31 12.7261 15.88 13.307 16.59 13.307C17.3 13.307 17.87 12.7261 17.87 12.025C17.87 11.314 17.3 10.7431 16.59 10.7431C15.88 10.7431 15.31 11.314 15.31 12.025ZM7.37 13.307C6.67 13.307 6.09 12.7261 6.09 12.025C6.09 11.314 6.66 10.7431 7.37 10.7431C8.08 10.7431 8.65 11.314 8.65 12.025C8.65 12.7261 8.08 13.2969 7.37 13.307Z"
      fill="currentColor"
    />
  </svg>
);

export const googleSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M23.06 12.25C23.06 11.47 22.99 10.72 22.86 10H12.5V14.255H18.42C18.165 15.63 17.39 16.795 16.225 17.575V20.335H19.78C21.86 18.42 23.06 15.6 23.06 12.25Z"
      fill="#4285F4"
    />
    <path
      d="M12.5 23.0001C15.47 23.0001 17.96 22.0151 19.78 20.3351L16.225 17.5751C15.24 18.2351 13.98 18.6251 12.5 18.6251C9.63501 18.6251 7.21001 16.6901 6.34501 14.0901H2.67001V16.9401C4.48001 20.5351 8.20001 23.0001 12.5 23.0001Z"
      fill="#34A853"
    />
    <path
      d="M6.345 14.0901C6.125 13.4301 6 12.7251 6 12.0001C6 11.2751 6.125 10.5701 6.345 9.91006V7.06006H2.67C1.9 8.59292 1.49932 10.2847 1.5 12.0001C1.5 13.7751 1.925 15.4551 2.67 16.9401L6.345 14.0901Z"
      fill="#FBBC05"
    />
    <path
      d="M12.5 5.375C14.115 5.375 15.565 5.93 16.705 7.02L19.86 3.865C17.955 2.09 15.465 1 12.5 1C8.20001 1 4.48001 3.465 2.67001 7.06L6.34501 9.91C7.21001 7.31 9.63501 5.375 12.5 5.375Z"
      fill="#EA4335"
    />
  </svg>
);
export const BookSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.625 13.5V5.25C2.625 2.25 3.375 1.5 6.375 1.5H11.625C14.625 1.5 15.375 2.25 15.375 5.25V12.75C15.375 12.855 15.375 12.96 15.3675 13.065"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.7625 11.25H15.375V13.875C15.375 15.3225 14.1975 16.5 12.75 16.5H5.25C3.8025 16.5 2.625 15.3225 2.625 13.875V13.3875C2.625 12.21 3.585 11.25 4.7625 11.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 5.25H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 7.875H9.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const closeGradientSvg = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="31"
      height="31"
      rx="15.5"
      stroke="url(#paint0_linear_7140_1229)"
    />
    <path
      d="M21.6478 11.1477C21.8674 10.9281 21.8674 10.5719 21.6478 10.3523C21.4281 10.1326 21.0719 10.1326 20.8523 10.3523L16 15.2045L11.1477 10.3523C10.9281 10.1326 10.5719 10.1326 10.3523 10.3523C10.1326 10.5719 10.1326 10.9281 10.3523 11.1477L15.2045 16L10.3523 20.8523C10.1326 21.0719 10.1326 21.4281 10.3523 21.6477C10.5719 21.8674 10.9281 21.8674 11.1478 21.6477L16 16.7955L20.8523 21.6477C21.0719 21.8674 21.4281 21.8674 21.6477 21.6477C21.8674 21.4281 21.8674 21.0719 21.6477 20.8523L16.7955 16L21.6478 11.1477Z"
      fill="url(#paint1_linear_7140_1229)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7140_1229"
        x1="0"
        y1="0"
        x2="33.1193"
        y2="11.5042"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDA61" />
        <stop offset="1" stopColor="#FF5ACD" stopOpacity="0.84" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7140_1229"
        x1="10.1875"
        y1="10.1875"
        x2="22.2192"
        y2="14.3668"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDA61" />
        <stop offset="1" stopColor="#FF5ACD" stopOpacity="0.84" />
      </linearGradient>
    </defs>
  </svg>
);
export const PartyPoper = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.326283 15.9033C0.634256 16.2313 1.90278 15.6593 2.90403 15.2007C3.65429 14.858 6.65668 13.6475 8.14906 13.0195C8.552 12.8502 9.13809 12.6288 9.56003 12.0835C9.93448 11.5982 10.9276 9.53703 8.9278 7.44916C6.89817 5.32929 4.80749 5.91459 4.02602 6.45855C3.5661 6.77853 3.19165 7.49982 3.02342 7.86647C2.3125 9.41571 1.29904 12.2542 0.886603 13.3701C0.584057 14.1928 0.0210239 15.578 0.326283 15.9033Z"
      fill="#FFC107"
    />
    <path
      d="M2.82226 8.33411C2.84125 8.56609 2.88874 8.9434 3.05154 9.67003C3.16279 10.1687 3.34459 10.6913 3.49247 11.0366C3.93612 12.0752 4.55884 12.4939 5.18971 12.8298C6.26151 13.4005 6.99006 13.5071 6.99006 13.5071L6.11634 13.8578C6.11634 13.8578 5.58723 13.7498 4.86546 13.4005C4.17761 13.0672 3.46127 12.5032 2.93758 11.3993C2.71101 10.9206 2.57941 10.4566 2.50343 10.0887C2.40982 9.6327 2.3949 9.37404 2.3949 9.37404L2.82226 8.33411Z"
      fill="#FF8F00"
    />
    <path
      d="M1.74839 11.0399C1.74839 11.0399 1.85692 11.9052 2.58412 12.9971C3.43613 14.2744 4.62596 14.4837 4.62596 14.4837L3.835 14.8037C3.835 14.8037 2.95179 14.5384 2.11199 13.4118C1.5883 12.7092 1.44177 11.8692 1.44177 11.8692L1.74839 11.0399Z"
      fill="#FF8F00"
    />
    <path
      d="M0.997479 13.0886C0.997479 13.0886 1.19556 13.8352 1.6297 14.3925C2.14661 15.0578 2.80461 15.2512 2.80461 15.2512L2.19816 15.5151C2.19816 15.5151 1.73824 15.4205 1.2349 14.7939C0.852311 14.3179 0.743774 13.7712 0.743774 13.7712L0.997479 13.0886Z"
      fill="#FF8F00"
    />
    <path
      opacity="0.44"
      d="M0.666424 14.9801C0.63929 14.9201 0.63929 14.8521 0.667781 14.7935L4.12331 7.75122L4.69177 9.85109L1.0558 15.0121C0.958116 15.1561 0.73833 15.1374 0.666424 14.9801Z"
      fill="#FFFDE7"
    />
    <path
      d="M4.96523 10.5553C6.57971 12.4112 8.41805 12.1792 9.02992 11.7099C9.64315 11.2393 10.1275 9.62204 8.5198 7.79682C6.83477 5.88493 4.92724 6.43023 4.48631 6.84354C4.04538 7.25685 3.4837 8.85275 4.96523 10.5553Z"
      fill="url(#paint0_linear_8782_602)"
    />
    <path
      d="M10.5132 11.3247C9.9244 10.8394 9.611 10.926 9.19042 11.098C8.64774 11.3194 7.79437 11.4833 6.63574 11.098L6.98442 10.2727C7.67227 10.5007 8.17018 10.3901 8.60025 10.1408C9.15379 9.82078 9.91083 9.38214 11.0885 10.3541C11.5796 10.7594 12.0829 11.0287 12.4519 10.906C12.7206 10.8181 12.863 10.4247 12.9349 10.1114C12.9417 10.0834 12.9526 10.0034 12.9607 9.93277C13.0258 9.44347 13.1344 8.38753 13.9348 7.84756C14.7909 7.27026 15.6904 7.27026 15.6904 7.27026L15.8532 8.8595C15.4394 8.79951 15.1518 8.88217 14.9089 9.01416C13.9945 9.51413 14.7909 11.434 13.3677 12.0793C11.9988 12.7046 10.8795 11.626 10.5132 11.3247Z"
      fill="#03A9F4"
    />
    <path
      d="M5.47576 9.29544L4.88695 8.7768C5.96825 7.59021 5.68334 6.71826 5.47576 6.08363C5.43371 5.95564 5.39436 5.83432 5.36858 5.71832C5.27633 5.30768 5.25733 4.95037 5.28582 4.63839C4.87067 4.13042 4.68752 3.59845 4.67531 3.56245C4.42296 2.81183 4.6129 2.07987 5.0484 1.39325C5.9289 0 7.52303 0 7.52303 0L8.05486 1.39858C7.65056 1.38258 6.32506 1.40258 5.91805 2.03321C5.40386 2.82783 5.74168 3.31847 5.7661 3.37446C5.86514 3.2478 5.96553 3.14648 6.05508 3.06782C6.70494 2.50118 7.26933 2.41985 7.62886 2.45185C8.03316 2.48785 8.39947 2.68784 8.66131 3.01582C8.94758 3.3758 9.06561 3.84377 8.97471 4.26908C8.88652 4.68372 8.60569 5.03436 8.18375 5.25702C7.44706 5.64633 6.83383 5.593 6.42274 5.45834C6.42546 5.46767 6.42681 5.47834 6.42953 5.48767C6.44445 5.55433 6.4743 5.64766 6.50957 5.75565C6.74971 6.48628 7.19607 7.64621 5.47576 9.29544ZM6.47294 4.29174C6.55163 4.34774 6.63439 4.3944 6.71986 4.42773C7.00477 4.53973 7.31546 4.5024 7.6682 4.31574C7.87578 4.20641 7.9002 4.08909 7.90834 4.05042C7.93276 3.93443 7.89206 3.78644 7.80387 3.67578C7.72654 3.57845 7.637 3.52779 7.52982 3.51712C7.32631 3.49979 7.0509 3.62645 6.77549 3.86777C6.64389 3.98376 6.54349 4.12642 6.47294 4.29174Z"
      fill="#F44336"
    />
    <path
      d="M7.83019 9.51361L6.98767 9.49095C6.98767 9.49095 7.3879 7.26975 8.68355 6.89644C8.9264 6.82711 9.19232 6.75644 9.45959 6.71778C9.61833 6.69378 9.86932 6.65778 9.99278 6.61245C10.0213 6.40313 9.93172 6.13648 9.83133 5.83383C9.75264 5.59918 9.67124 5.35786 9.62782 5.09388C9.54371 4.57924 9.68345 4.1246 10.0213 3.81129C10.4337 3.43131 11.0998 3.30998 11.8515 3.47797C12.2802 3.57397 12.5963 3.78062 12.8744 3.96194C13.2719 4.22193 13.5039 4.35392 13.9896 4.03261C14.5771 3.6433 13.8092 2.11939 13.4008 1.23944L14.9244 0.615479C15.1293 1.05545 16.1183 3.31932 15.4657 4.61124C15.2459 5.04588 14.8674 5.33386 14.3709 5.44186C13.2909 5.67917 12.6587 5.26587 12.1974 4.96455C11.979 4.82189 11.7877 4.7099 11.5801 4.65124C10.1379 4.24726 12.1513 6.33247 11.2084 7.26975C10.6426 7.83105 9.26015 7.97904 9.17061 8.00037C8.28061 8.21102 7.83019 9.51361 7.83019 9.51361Z"
      fill="#F48FB1"
    />
    <path
      d="M5.2825 4.63989C5.25673 4.93321 5.24452 5.10786 5.32185 5.48917C5.69494 5.75849 6.50761 5.75849 6.50761 5.75849C6.47234 5.6505 6.44113 5.55717 6.42756 5.49051C6.42485 5.48117 6.42349 5.47051 6.42078 5.46118C5.59455 5.05587 5.2825 4.63989 5.2825 4.63989Z"
      fill="#C92B27"
    />
    <path
      d="M3.59436 5.9511L2.19153 5.27514L2.89023 4.2832L3.99052 4.99916L3.59436 5.9511Z"
      fill="#FFC107"
    />
    <path
      d="M1.5263 4.0824C0.809954 3.98774 0.0800457 3.39045 0 3.32245L0.704131 2.5105C0.917134 2.68782 1.36892 2.98514 1.67146 3.02513L1.5263 4.0824Z"
      fill="#FB8C00"
    />
    <path
      d="M2.79245 2.30676L1.76135 1.97478C1.87939 1.62013 1.91059 1.23749 1.84954 0.868176L2.92134 0.698853C3.00952 1.23482 2.96475 1.79079 2.79245 2.30676Z"
      fill="#03A9F4"
    />
    <path
      d="M9.22998 1.51221L10.2903 1.28427L10.5964 2.65967L9.53614 2.8876L9.22998 1.51221Z"
      fill="#FB8C00"
    />
    <path
      d="M11.8591 1.83694L11.1129 1.06232C11.5036 0.698345 11.5932 0.222374 11.5932 0.217041L12.665 0.389031C12.6514 0.473026 12.5144 1.22765 11.8591 1.83694Z"
      fill="#FFC107"
    />
    <path
      d="M12.2765 5.94641L13.2244 5.65529L13.5482 6.67336L12.6003 6.96448L12.2765 5.94641Z"
      fill="#FB8C00"
    />
    <path
      d="M12.5489 14.5365L11.4703 14.4112C11.5164 14.0339 11.2302 13.5712 11.1515 13.4686L12.0198 12.8286C12.0849 12.9126 12.6507 13.6819 12.5489 14.5365Z"
      fill="#F44336"
    />
    <path
      d="M15.6453 13.1852C15.2397 13.1252 14.8245 13.1012 14.4148 13.1159L14.3782 12.0493C14.8544 12.0333 15.336 12.06 15.8068 12.1306L15.6453 13.1852Z"
      fill="#FB8C00"
    />
    <path
      d="M14.189 14.6552L14.9511 13.8966L16 14.9143L15.2378 15.6729L14.189 14.6552Z"
      fill="#F48FB1"
    />
    <path
      d="M11.9484 7.91443L12.7321 8.79501L11.8359 9.56526L11.0522 8.68468L11.9484 7.91443Z"
      fill="#F44336"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8782_602"
        x1="9.40631"
        y1="7.70862"
        x2="5.40535"
        y2="10.1514"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0235" stopColor="#8F4700" />
        <stop offset="1" stopColor="#703E2D" />
      </linearGradient>
    </defs>
  </svg>
);

export const PercentileFlow = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.625 5.54163L7.175 7.99163L6.24167 6.59163L4.375 8.45829"
      stroke="#76F368"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.45825 5.54163H9.62492V6.70829"
      stroke="#76F368"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25008 12.8333H8.75008C11.6667 12.8333 12.8334 11.6666 12.8334 8.74996V5.24996C12.8334 2.33329 11.6667 1.16663 8.75008 1.16663H5.25008C2.33341 1.16663 1.16675 2.33329 1.16675 5.24996V8.74996C1.16675 11.6666 2.33341 12.8333 5.25008 12.8333Z"
      stroke="#76F368"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CancelBtn = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.28125"
      y="0.28125"
      width="17.4375"
      height="17.4375"
      rx="8.71875"
      stroke="currentColor"
      strokeWidth="0.5625"
    />
    <path
      d="M12.1769 6.27061C12.3004 6.14704 12.3004 5.94671 12.1769 5.82314C12.0533 5.69958 11.853 5.69958 11.7294 5.82314L9 8.55254L6.27061 5.82314C6.14704 5.69958 5.94671 5.69958 5.82314 5.82314C5.69958 5.94671 5.69958 6.14704 5.82314 6.27061L8.55254 9.00001L5.82315 11.7294C5.69959 11.853 5.69959 12.0533 5.82315 12.1769C5.94672 12.3004 6.14706 12.3004 6.27062 12.1769L9.00001 9.44747L11.7294 12.1769C11.853 12.3004 12.0533 12.3004 12.1769 12.1769C12.3004 12.0533 12.3004 11.853 12.1769 11.7294L9.44747 9.00001L12.1769 6.27061Z"
      fill="currentColor"
    />
  </svg>
);

export const cancelIconSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6478 4.14775C14.8674 3.92808 14.8674 3.57192 14.6478 3.35225C14.4281 3.13258 14.0719 3.13258 13.8523 3.35225L9.00001 8.20452L4.14775 3.35225C3.92808 3.13258 3.57192 3.13258 3.35225 3.35225C3.13258 3.57192 3.13258 3.92808 3.35225 4.14775L8.20451 9.00001L3.35227 13.8523C3.1326 14.0719 3.1326 14.4281 3.35227 14.6477C3.57194 14.8674 3.9281 14.8674 4.14777 14.6477L9.00001 9.79551L13.8523 14.6477C14.0719 14.8674 14.4281 14.8674 14.6477 14.6477C14.8674 14.4281 14.8674 14.0719 14.6477 13.8523L9.7955 9.00001L14.6478 4.14775Z"
      fill="#FEFEFE"
    />
  </svg>
);

export const notificationSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.01494 2.1825C6.53244 2.1825 4.51494 4.2 4.51494 6.6825V8.85C4.51494 9.3075 4.31994 10.005 4.08744 10.395L3.22494 11.8275C2.69244 12.7125 3.05994 13.695 4.03494 14.025C7.26744 15.105 10.7549 15.105 13.9874 14.025C14.8949 13.725 15.2924 12.6525 14.7974 11.8275L13.9349 10.395C13.7099 10.005 13.5149 9.3075 13.5149 8.85V6.6825C13.5149 4.2075 11.4899 2.1825 9.01494 2.1825Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M10.4024 2.39996C10.1699 2.33246 9.92994 2.27996 9.68244 2.24996C8.96244 2.15996 8.27244 2.21246 7.62744 2.39996C7.84494 1.84496 8.38494 1.45496 9.01494 1.45496C9.64494 1.45496 10.1849 1.84496 10.4024 2.39996Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.265 14.295C11.265 15.5325 10.2525 16.545 9.01501 16.545C8.40001 16.545 7.83001 16.29 7.42501 15.885C7.02001 15.48 6.76501 14.91 6.76501 14.295"
      stroke="#888888"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);
export const likeSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.21 16.575H9.36002C8.94002 16.575 8.02502 16.4475 7.53752 15.96L5.26502 14.205L5.95502 13.3125L8.28002 15.1125C8.46752 15.2925 8.94002 15.4425 9.36002 15.4425H12.21C12.885 15.4425 13.6125 14.9025 13.7625 14.295L15.5775 8.78249C15.6975 8.45249 15.675 8.15249 15.5175 7.93499C15.3525 7.70249 15.0525 7.56749 14.685 7.56749H11.685C11.295 7.56749 10.935 7.40249 10.6875 7.11749C10.4325 6.82499 10.32 6.43499 10.38 6.02999L10.755 3.62249C10.845 3.20249 10.56 2.72999 10.155 2.59499C9.78752 2.45999 9.31502 2.65499 9.15002 2.89499L6.07502 7.46999L5.14502 6.84749L8.22002 2.27249C8.69252 1.56749 9.72752 1.22999 10.5375 1.53749C11.475 1.84499 12.075 2.87999 11.865 3.83999L11.4975 6.20249C11.49 6.25499 11.49 6.32999 11.5425 6.38999C11.58 6.42749 11.6325 6.44999 11.6925 6.44999H14.6925C15.4275 6.44999 16.065 6.75749 16.44 7.28999C16.8075 7.80749 16.8825 8.48999 16.6425 9.14999L14.85 14.61C14.5725 15.6975 13.4175 16.575 12.21 16.575Z"
      fill="currentColor"
    />
    <path
      d="M4.03503 15.75H3.28503C1.89753 15.75 1.22253 15.0975 1.22253 13.7625V6.4125C1.22253 5.0775 1.89753 4.425 3.28503 4.425H4.03503C5.42253 4.425 6.09753 5.0775 6.09753 6.4125V13.7625C6.09753 15.0975 5.42253 15.75 4.03503 15.75ZM3.28503 5.55C2.46753 5.55 2.34753 5.745 2.34753 6.4125V13.7625C2.34753 14.43 2.46753 14.625 3.28503 14.625H4.03503C4.85253 14.625 4.97253 14.43 4.97253 13.7625V6.4125C4.97253 5.745 4.85253 5.55 4.03503 5.55H3.28503Z"
      fill="currentColor"
    />
  </svg>
);

export const dislikeSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.10003 16.575C7.88253 16.575 7.66503 16.5375 7.46253 16.4625C6.52503 16.155 5.92503 15.12 6.13503 14.16L6.50253 11.7975C6.51003 11.745 6.51003 11.67 6.45753 11.61C6.42003 11.5725 6.36753 11.55 6.30753 11.55H3.30753C2.57253 11.55 1.93503 11.2425 1.56003 10.71C1.19253 10.1925 1.11753 9.51 1.35753 8.85L3.15003 3.39C3.42753 2.3025 4.59003 1.425 5.79003 1.425H8.64003C9.06003 1.425 9.97503 1.5525 10.4625 2.04L12.735 3.795L12.045 4.6875L9.72003 2.8875C9.53253 2.7 9.06003 2.55 8.64003 2.55H5.79003C5.11503 2.55 4.38753 3.09 4.23753 3.6975L2.42253 9.21C2.30253 9.54 2.32503 9.84 2.48253 10.0575C2.64753 10.29 2.94753 10.425 3.31503 10.425H6.31503C6.70503 10.425 7.06503 10.59 7.31253 10.875C7.56753 11.1675 7.68003 11.5575 7.62003 11.9625L7.24503 14.37C7.15503 14.79 7.44003 15.2625 7.84503 15.3975C8.20503 15.5325 8.68503 15.3375 8.85003 15.0975L11.925 10.5225L12.855 11.1525L9.78003 15.7275C9.42753 16.2525 8.76003 16.575 8.10003 16.575Z"
      fill="currentColor"
    />
    <path
      d="M14.715 13.575H13.965C12.5775 13.575 11.9025 12.9225 11.9025 11.5875V4.2375C11.9025 2.9025 12.5775 2.25 13.965 2.25H14.715C16.1025 2.25 16.7775 2.9025 16.7775 4.2375V11.5875C16.7775 12.9225 16.1025 13.575 14.715 13.575ZM13.965 3.375C13.1475 3.375 13.0275 3.57 13.0275 4.2375V11.5875C13.0275 12.255 13.1475 12.45 13.965 12.45H14.715C15.5325 12.45 15.6525 12.255 15.6525 11.5875V4.2375C15.6525 3.57 15.5325 3.375 14.715 3.375H13.965Z"
      fill="currentColor"
    />
  </svg>
);

export const successSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99999 18.3334C14.5833 18.3334 18.3333 14.5834 18.3333 10.0001C18.3333 5.41675 14.5833 1.66675 9.99999 1.66675C5.41666 1.66675 1.66666 5.41675 1.66666 10.0001C1.66666 14.5834 5.41666 18.3334 9.99999 18.3334Z"
      stroke="#1AFF8C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.45834 9.99993L8.81668 12.3583L13.5417 7.6416"
      stroke="#1AFF8C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const filterSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.04999 1.57495H13.95C14.775 1.57495 15.45 2.24995 15.45 3.07495V4.72495C15.45 5.32495 15.075 6.07495 14.7 6.44995L11.475 9.29995C11.025 9.67495 10.725 10.425 10.725 11.025V14.25C10.725 14.7 10.425 15.3 10.05 15.525L8.99999 16.2C8.02499 16.8 6.67499 16.125 6.67499 14.925V10.95C6.67499 10.425 6.37499 9.74995 6.07499 9.37495L3.22499 6.37495C2.84999 5.99995 2.54999 5.32495 2.54999 4.87495V3.14995C2.54999 2.24995 3.22499 1.57495 4.04999 1.57495Z"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.1975 1.57495L4.5 7.49995"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const infoSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.06266 1.83749C8.58766 1.39499 9.43516 1.39499 9.94516 1.83749L11.1302 2.84999C11.3552 3.03749 11.7827 3.19499 12.0827 3.19499H13.3577C14.1527 3.19499 14.8052 3.84749 14.8052 4.64249V5.91749C14.8052 6.21749 14.9627 6.63749 15.1502 6.86249L16.1627 8.04749C16.6052 8.57249 16.6052 9.41999 16.1627 9.92999L15.1502 11.115C14.9627 11.34 14.8052 11.76 14.8052 12.06V13.335C14.8052 14.13 14.1527 14.7825 13.3577 14.7825H12.0827C11.7827 14.7825 11.3627 14.94 11.1377 15.1275L9.95266 16.14C9.42766 16.5825 8.58016 16.5825 8.07016 16.14L6.88516 15.1275C6.66016 14.94 6.23266 14.7825 5.94016 14.7825H4.62766C3.83266 14.7825 3.18016 14.13 3.18016 13.335V12.0525C3.18016 11.76 3.03016 11.3325 2.84266 11.115L1.83016 9.92249C1.39516 9.40499 1.39516 8.56499 1.83016 8.04749L2.84266 6.85499C3.03016 6.62999 3.18016 6.20999 3.18016 5.91749V4.64999C3.18016 3.85499 3.83266 3.20249 4.62766 3.20249H5.92516C6.22516 3.20249 6.64516 3.04499 6.87016 2.85749L8.06266 1.83749Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 6.09753V9.72003"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.99609 12H9.00283"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const eightyTwentyIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.50758 0L8.00343 4.04258L12.0459 5.53846L8.00343 7.03435L6.50758 11.0769L5.01172 7.03435L0.969238 5.53846L5.01172 4.04258L6.50758 0Z"
      fill="#FDD649"
    />
    <path
      d="M13.2923 6.36914L14.302 9.09788L17.0307 10.1076L14.302 11.1173L13.2923 13.8461L12.2826 11.1173L9.55396 10.1076L12.2826 9.09788L13.2923 6.36914Z"
      fill="#008D82"
    />
    <path
      d="M6.64615 12.1846L7.43148 14.3069L9.55378 15.0923L7.43148 15.8776L6.64615 18L5.86083 15.8776L3.73853 15.0923L5.86083 14.3069L6.64615 12.1846Z"
      fill="#FFEFCA"
    />
  </svg>
);

export const sharePrompt = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 8.24998L15.9 2.09998"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 5.1225V1.5H12.8775"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const gradientButton = (
  <svg
    width="56"
    height="40"
    viewBox="0 0 56 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="55"
      height="39"
      rx="19.5"
      stroke="url(#paint0_linear_11499_7919)"
    />
    <path
      d="M21 18C19.9 18 19 18.9 19 20C19 21.1 19.9 22 21 22C22.1 22 23 21.1 23 20C23 18.9 22.1 18 21 18Z"
      stroke="url(#paint1_linear_11499_7919)"
      strokeWidth="1.5"
    />
    <path
      d="M35 18C33.9 18 33 18.9 33 20C33 21.1 33.9 22 35 22C36.1 22 37 21.1 37 20C37 18.9 36.1 18 35 18Z"
      stroke="url(#paint2_linear_11499_7919)"
      strokeWidth="1.5"
    />
    <path
      d="M28 18C26.9 18 26 18.9 26 20C26 21.1 26.9 22 28 22C29.1 22 30 21.1 30 20C30 18.9 29.1 18 28 18Z"
      stroke="url(#paint3_linear_11499_7919)"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11499_7919"
        x1="0"
        y1="0"
        x2="52.5295"
        y2="25.545"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDA61" />
        <stop offset="1" stopColor="#FF5ACD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11499_7919"
        x1="19"
        y1="18"
        x2="23.1399"
        y2="19.438"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDA61" />
        <stop offset="1" stopColor="#FF5ACD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_11499_7919"
        x1="33"
        y1="18"
        x2="37.1399"
        y2="19.438"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDA61" />
        <stop offset="1" stopColor="#FF5ACD" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_11499_7919"
        x1="26"
        y1="18"
        x2="30.1399"
        y2="19.438"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDA61" />
        <stop offset="1" stopColor="#FF5ACD" />
      </linearGradient>
    </defs>
  </svg>
);

export const projectSvg = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="39" height="39" rx="9.5" stroke="#292929" />
    <path
      d="M29 15V25C29 28 27.5 30 24 30H16C12.5 30 11 28 11 25V15C11 12 12.5 10 16 10H24C27.5 10 29 12 29 15Z"
      stroke="#F43E5C"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.5 12.5V14.5C22.5 15.6 23.4 16.5 24.5 16.5H26.5"
      stroke="#F43E5C"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 21L16 23L18 25"
      stroke="#F43E5C"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 21L24 23L22 25"
      stroke="#F43E5C"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const commitSvg = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="5.5" stroke="#696969" />
    <rect x="1" y="5.5" width="4" height="1" fill="#696969" />
    <circle cx="6" cy="6" r="1" fill="#696969" />
    <rect x="7" y="5.5" width="4" height="1" fill="#696969" />
  </svg>
);

export const twitterSvg = (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11511_6000)">
      <path
        d="M10.4533 0H12.48L8.05333 5.09333L13.28 12H9.17333L5.97333 7.81333L2.29333 12H0.266667L5.01333 6.56L0 0H4.21333L7.12 3.84L10.4533 0ZM9.73333 10.7733H10.8533L3.6 1.14667H2.37333L9.73333 10.7733Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_11511_6000">
        <rect width="13.28" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const goldSvg = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
      fill="#FFBB0D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5185 7.99996C15.5185 12.1523 12.1523 15.5185 7.99996 15.5185C3.8476 15.5185 0.481445 12.1523 0.481445 7.99996C0.481445 3.8476 3.8476 0.481445 7.99996 0.481445C12.1523 0.481445 15.5185 3.8476 15.5185 7.99996ZM7.99996 15C11.866 15 15 11.866 15 7.99996C15 4.13397 11.866 0.999964 7.99996 0.999964C4.13397 0.999964 0.999964 4.13397 0.999964 7.99996C0.999964 11.866 4.13397 15 7.99996 15Z"
      fill="#E89B05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.51805 8.25928C1.37486 8.25928 1.25879 8.1432 1.25879 8.00002C1.25879 4.27721 4.27672 1.25928 7.99953 1.25928C8.14272 1.25928 8.25879 1.37535 8.25879 1.51854C8.25879 1.66172 8.14272 1.7778 7.99953 1.7778C4.56309 1.7778 1.77731 4.56358 1.77731 8.00002C1.77731 8.1432 1.66123 8.25928 1.51805 8.25928Z"
      fill="#E8AA0A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.481 7.74072C14.6242 7.74072 14.7402 7.8568 14.7402 7.99998C14.7402 11.7228 11.7223 14.7407 7.99949 14.7407C7.85631 14.7407 7.74023 14.6246 7.74023 14.4815C7.74023 14.3383 7.85631 14.2222 7.99949 14.2222C11.4359 14.2222 14.2217 11.4364 14.2217 7.99998C14.2217 7.8568 14.3378 7.74072 14.481 7.74072Z"
      fill="#E8AA0A"
    />
    <path
      d="M13.1848 7.99988C13.1848 10.8636 10.8633 13.1851 7.99964 13.1851C5.13594 13.1851 2.81445 10.8636 2.81445 7.99988C2.81445 5.13618 5.13594 2.8147 7.99964 2.8147C10.8633 2.8147 13.1848 5.13618 13.1848 7.99988Z"
      fill="#FFDD28"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7033 7.99985C13.7033 11.1499 11.1497 13.7036 7.9996 13.7036C4.84953 13.7036 2.2959 11.1499 2.2959 7.99985C2.2959 4.84978 4.84953 2.29614 7.9996 2.29614C11.1497 2.29614 13.7033 4.84978 13.7033 7.99985ZM7.9996 13.185C10.8633 13.185 13.1848 10.8635 13.1848 7.99985C13.1848 5.13615 10.8633 2.81466 7.9996 2.81466C5.1359 2.81466 2.81442 5.13615 2.81442 7.99985C2.81442 10.8635 5.1359 13.185 7.9996 13.185Z"
      fill="#E89B05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99986 12.4073C10.434 12.4073 12.4073 10.434 12.4073 7.99986C12.4073 7.85667 12.5233 7.7406 12.6665 7.7406C12.8097 7.7406 12.9258 7.85667 12.9258 7.99986C12.9258 10.7204 10.7204 12.9258 7.99986 12.9258C7.85667 12.9258 7.7406 12.8097 7.7406 12.6665C7.7406 12.5233 7.85667 12.4073 7.99986 12.4073Z"
      fill="#ECC704"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00014 3.59249C5.566 3.59249 3.59274 5.56576 3.59274 7.9999C3.59274 8.14309 3.47666 8.25916 3.33348 8.25916C3.19029 8.25916 3.07422 8.14309 3.07422 7.9999C3.07422 5.27939 5.27963 3.07397 8.00014 3.07397C8.14333 3.07397 8.2594 3.19005 8.2594 3.33323C8.2594 3.47642 8.14333 3.59249 8.00014 3.59249Z"
      fill="#FFEF9C"
    />
  </svg>
);

export const bronzeSvg = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
      fill="#DCA16A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5185 7.99996C15.5185 12.1523 12.1523 15.5185 7.99996 15.5185C3.8476 15.5185 0.481445 12.1523 0.481445 7.99996C0.481445 3.8476 3.8476 0.481445 7.99996 0.481445C12.1523 0.481445 15.5185 3.8476 15.5185 7.99996ZM7.99996 15C11.866 15 15 11.866 15 7.99996C15 4.13397 11.866 0.999964 7.99996 0.999964C4.13397 0.999964 0.999964 4.13397 0.999964 7.99996C0.999964 11.866 4.13397 15 7.99996 15Z"
      fill="#C38144"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.51805 8.25928C1.37486 8.25928 1.25879 8.1432 1.25879 8.00002C1.25879 4.27721 4.27672 1.25928 7.99953 1.25928C8.14272 1.25928 8.25879 1.37535 8.25879 1.51854C8.25879 1.66172 8.14272 1.7778 7.99953 1.7778C4.56309 1.7778 1.77731 4.56358 1.77731 8.00002C1.77731 8.1432 1.66123 8.25928 1.51805 8.25928Z"
      fill="#F0B57F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.482 7.74072C14.6251 7.74072 14.7412 7.8568 14.7412 7.99998C14.7412 11.7228 11.7233 14.7407 8.00047 14.7407C7.85729 14.7407 7.74121 14.6246 7.74121 14.4815C7.74121 14.3383 7.85729 14.2222 8.00047 14.2222C11.4369 14.2222 14.2227 11.4364 14.2227 7.99998C14.2227 7.8568 14.3388 7.74072 14.482 7.74072Z"
      fill="#CF945D"
    />
    <path
      d="M13.1848 7.99988C13.1848 10.8636 10.8633 13.1851 7.99964 13.1851C5.13594 13.1851 2.81445 10.8636 2.81445 7.99988C2.81445 5.13618 5.13594 2.8147 7.99964 2.8147C10.8633 2.8147 13.1848 5.13618 13.1848 7.99988Z"
      fill="#F7BA82"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7033 8.00009C13.7033 11.1502 11.1497 13.7038 7.9996 13.7038C4.84953 13.7038 2.2959 11.1502 2.2959 8.00009C2.2959 4.85002 4.84953 2.29639 7.9996 2.29639C11.1497 2.29639 13.7033 4.85002 13.7033 8.00009ZM7.9996 13.1853C10.8633 13.1853 13.1848 10.8638 13.1848 8.00009C13.1848 5.13639 10.8633 2.81491 7.9996 2.81491C5.1359 2.81491 2.81442 5.13639 2.81442 8.00009C2.81442 10.8638 5.1359 13.1853 7.9996 13.1853Z"
      fill="#C38144"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99986 12.4075C10.434 12.4075 12.4073 10.4342 12.4073 8.0001C12.4073 7.85691 12.5233 7.74084 12.6665 7.74084C12.8097 7.74084 12.9258 7.85691 12.9258 8.0001C12.9258 10.7206 10.7204 12.926 7.99986 12.926C7.85667 12.926 7.7406 12.81 7.7406 12.6668C7.7406 12.5236 7.85667 12.4075 7.99986 12.4075Z"
      fill="#E6A66C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00014 3.59249C5.566 3.59249 3.59274 5.56576 3.59274 7.9999C3.59274 8.14309 3.47666 8.25916 3.33348 8.25916C3.19029 8.25916 3.07422 8.14309 3.07422 7.9999C3.07422 5.27939 5.27963 3.07397 8.00014 3.07397C8.14333 3.07397 8.2594 3.19005 8.2594 3.33323C8.2594 3.47642 8.14333 3.59249 8.00014 3.59249Z"
      fill="#FFD5AE"
    />
  </svg>
);

export const silverSvg = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
      fill="#BCCCD2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5185 7.99996C15.5185 12.1523 12.1523 15.5185 7.99996 15.5185C3.8476 15.5185 0.481445 12.1523 0.481445 7.99996C0.481445 3.8476 3.8476 0.481445 7.99996 0.481445C12.1523 0.481445 15.5185 3.8476 15.5185 7.99996ZM7.99996 15C11.866 15 15 11.866 15 7.99996C15 4.13397 11.866 0.999964 7.99996 0.999964C4.13397 0.999964 0.999964 4.13397 0.999964 7.99996C0.999964 11.866 4.13397 15 7.99996 15Z"
      fill="#81A5B0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.51805 8.25928C1.37486 8.25928 1.25879 8.1432 1.25879 8.00002C1.25879 4.27721 4.27672 1.25928 7.99953 1.25928C8.14272 1.25928 8.25879 1.37535 8.25879 1.51854C8.25879 1.66172 8.14272 1.7778 7.99953 1.7778C4.56309 1.7778 1.77731 4.56358 1.77731 8.00002C1.77731 8.1432 1.66123 8.25928 1.51805 8.25928Z"
      fill="#D0DEE3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.482 7.74072C14.6251 7.74072 14.7412 7.8568 14.7412 7.99998C14.7412 11.7228 11.7233 14.7407 8.00047 14.7407C7.85729 14.7407 7.74121 14.6246 7.74121 14.4815C7.74121 14.3383 7.85729 14.2222 8.00047 14.2222C11.4369 14.2222 14.2227 11.4364 14.2227 7.99998C14.2227 7.8568 14.3388 7.74072 14.482 7.74072Z"
      fill="#A2B9C1"
    />
    <path
      d="M13.1848 7.99988C13.1848 10.8636 10.8633 13.1851 7.99964 13.1851C5.13594 13.1851 2.81445 10.8636 2.81445 7.99988C2.81445 5.13618 5.13594 2.8147 7.99964 2.8147C10.8633 2.8147 13.1848 5.13618 13.1848 7.99988Z"
      fill="#C7D4D8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7033 8.00009C13.7033 11.1502 11.1497 13.7038 7.9996 13.7038C4.84953 13.7038 2.2959 11.1502 2.2959 8.00009C2.2959 4.85002 4.84953 2.29639 7.9996 2.29639C11.1497 2.29639 13.7033 4.85002 13.7033 8.00009ZM7.9996 13.1853C10.8633 13.1853 13.1848 10.8638 13.1848 8.00009C13.1848 5.13639 10.8633 2.81491 7.9996 2.81491C5.1359 2.81491 2.81442 5.13639 2.81442 8.00009C2.81442 10.8638 5.1359 13.1853 7.9996 13.1853Z"
      fill="#81A5B0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99986 12.4075C10.434 12.4075 12.4073 10.4342 12.4073 8.0001C12.4073 7.85691 12.5233 7.74084 12.6665 7.74084C12.8097 7.74084 12.9258 7.85691 12.9258 8.0001C12.9258 10.7206 10.7204 12.926 7.99986 12.926C7.85667 12.926 7.7406 12.81 7.7406 12.6668C7.7406 12.5236 7.85667 12.4075 7.99986 12.4075Z"
      fill="#B5C3C8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00014 3.59249C5.566 3.59249 3.59274 5.56576 3.59274 7.9999C3.59274 8.14309 3.47666 8.25916 3.33348 8.25916C3.19029 8.25916 3.07422 8.14309 3.07422 7.9999C3.07422 5.27939 5.27963 3.07397 8.00014 3.07397C8.14333 3.07397 8.2594 3.19005 8.2594 3.33323C8.2594 3.47642 8.14333 3.59249 8.00014 3.59249Z"
      fill="#D9EAEF"
    />
  </svg>
);

export const userSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.11992 8.1525C9.04492 8.145 8.95492 8.145 8.87242 8.1525C7.08742 8.0925 5.66992 6.63 5.66992 4.83C5.66992 2.9925 7.15492 1.5 8.99992 1.5C10.8374 1.5 12.3299 2.9925 12.3299 4.83C12.3224 6.63 10.9049 8.0925 9.11992 8.1525Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.37004 10.92C3.55504 12.135 3.55504 14.115 5.37004 15.3225C7.43254 16.7025 10.815 16.7025 12.8775 15.3225C14.6925 14.1075 14.6925 12.1275 12.8775 10.92C10.8225 9.5475 7.44004 9.5475 5.37004 10.92Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const dropdownSvg = (
  <svg
    width="56"
    height="40"
    viewBox="0 0 56 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="55"
      height="39"
      rx="19.5"
      stroke="url(#paint0_linear_11499_7919)"
    />
    <path
      d="M21 18C19.9 18 19 18.9 19 20C19 21.1 19.9 22 21 22C22.1 22 23 21.1 23 20C23 18.9 22.1 18 21 18Z"
      stroke="url(#paint1_linear_11499_7919)"
      strokeWidth="1.5"
    />
    <path
      d="M35 18C33.9 18 33 18.9 33 20C33 21.1 33.9 22 35 22C36.1 22 37 21.1 37 20C37 18.9 36.1 18 35 18Z"
      stroke="url(#paint2_linear_11499_7919)"
      strokeWidth="1.5"
    />
    <path
      d="M28 18C26.9 18 26 18.9 26 20C26 21.1 26.9 22 28 22C29.1 22 30 21.1 30 20C30 18.9 29.1 18 28 18Z"
      stroke="url(#paint3_linear_11499_7919)"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11499_7919"
        x1="0"
        y1="0"
        x2="52.5295"
        y2="25.545"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDA61" />
        <stop offset="1" stopColor="#FF5ACD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11499_7919"
        x1="19"
        y1="18"
        x2="23.1399"
        y2="19.438"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDA61" />
        <stop offset="1" stopColor="#FF5ACD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_11499_7919"
        x1="33"
        y1="18"
        x2="37.1399"
        y2="19.438"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDA61" />
        <stop offset="1" stopColor="#FF5ACD" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_11499_7919"
        x1="26"
        y1="18"
        x2="30.1399"
        y2="19.438"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDA61" />
        <stop offset="1" stopColor="#FF5ACD" />
      </linearGradient>
    </defs>
  </svg>
);

export const dotsSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10Z"
      stroke="url(#paint0_linear_11511_2294)"
      strokeWidth="1.5"
    />
    <path
      d="M19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10Z"
      stroke="url(#paint1_linear_11511_2294)"
      strokeWidth="1.5"
    />
    <path
      d="M12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
      stroke="url(#paint2_linear_11511_2294)"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11511_2294"
        x1="3"
        y1="10"
        x2="7.13992"
        y2="11.438"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDA61" />
        <stop offset="1" stopColor="#FF5ACD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11511_2294"
        x1="17"
        y1="10"
        x2="21.1399"
        y2="11.438"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDA61" />
        <stop offset="1" stopColor="#FF5ACD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_11511_2294"
        x1="10"
        y1="10"
        x2="14.1399"
        y2="11.438"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDA61" />
        <stop offset="1" stopColor="#FF5ACD" />
      </linearGradient>
    </defs>
  </svg>
);

export const heroSvg = (
  <svg
    width="82"
    height="83"
    viewBox="0 0 82 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.6484 46.0211L32.2391 45.9839C27.0191 45.5093 24.4091 45.272 23.58 43.4865C22.7509 41.701 24.2539 39.554 27.2597 35.2599L39.5007 17.7727C41.4865 14.936 42.4793 13.5176 43.3356 13.8192C44.1919 14.1208 44.0768 15.8483 43.8464 19.3034L43.1521 29.7191C42.9425 32.8631 42.8377 34.4352 43.7411 35.4931C44.6445 36.551 46.2135 36.6937 49.3516 36.9789L49.7609 37.0161C54.9809 37.4907 57.5909 37.728 58.42 39.5135C59.2491 41.299 57.7461 43.446 54.7403 47.7401L42.4993 65.2272C40.5135 68.064 39.5207 69.4824 38.6644 69.1808C37.8081 68.8792 37.9232 67.1517 38.1536 63.6966L38.8479 53.2809C39.0575 50.1369 39.1623 48.5648 38.2589 47.5069C37.3555 46.449 35.7865 46.3063 32.6484 46.0211Z"
      fill="#FDD649"
    />
    <path
      d="M63.2083 14.1667L58.0833 21.0001H64.9167L59.7917 27.8334"
      stroke="#7E869E"
      strokeOpacity="0.25"
      strokeWidth="3.41667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.2083 55.1667L17.0833 62.0001H23.9167L18.7917 68.8334"
      stroke="#7E869E"
      strokeOpacity="0.25"
      strokeWidth="3.41667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const codeSymbol = (
  <svg
    width="86"
    height="86"
    viewBox="0 0 86 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="85"
      height="85"
      rx="19.5"
      fill="url(#paint0_linear_3271_6876)"
    />
    <rect x="0.5" y="0.5" width="85" height="85" rx="19.5" stroke="#2A2A2D" />
    <path
      d="M29.4319 54.5471C28.8234 54.5471 28.2138 54.325 27.7346 53.8767L15.368 42.3078C14.8657 41.8379 14.5806 41.1808 14.5806 40.4928C14.5806 39.8049 14.8657 39.1478 15.368 38.6778L21.5512 32.8932L27.7346 27.1089C28.7369 26.1711 30.3096 26.2236 31.2474 27.2259C32.1851 28.2282 32.1327 29.801 31.1303 30.7387L20.7038 40.4928L31.1303 50.2467C32.1327 51.1844 32.1851 52.7572 31.2474 53.7595C30.758 54.2826 30.0957 54.5471 29.4319 54.5471Z"
      fill="#FDD649"
    />
    <path
      d="M56.1079 54.547C55.444 54.547 54.7818 54.2827 54.2924 53.7596C53.3548 52.7573 53.4071 51.1845 54.4095 50.2468L64.836 40.4929L60.5928 36.5233L54.4096 30.739C53.4073 29.8012 53.3548 28.2285 54.2925 27.2262C55.2303 26.2238 56.803 26.1714 57.8054 27.1091L63.9886 32.8934L70.1719 38.678C70.6744 39.1479 70.9594 39.805 70.9594 40.493C70.9594 41.1809 70.6742 41.838 70.1719 42.308L57.8054 53.8769C57.3261 54.325 56.7164 54.547 56.1079 54.547Z"
      fill="#FDD649"
    />
    <path
      d="M37.2366 58.6127C36.9485 58.6127 36.6559 58.5624 36.3702 58.4561C35.0838 57.9774 34.429 56.5465 34.9077 55.2601L45.7527 26.1141C46.2313 24.8277 47.6623 24.1729 48.9487 24.6516C50.2351 25.1303 50.89 26.5612 50.4113 27.8476L39.5663 56.9936C39.1939 57.9942 38.2451 58.6127 37.2366 58.6127Z"
      fill="#FDD649"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3271_6876"
        x1="43"
        y1="0"
        x2="43"
        y2="86"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#19191B" />
        <stop offset="1" stop-color="#2A2A2D" />
      </linearGradient>
    </defs>
  </svg>
);

export const howSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 2.43005H7C4 2.43005 2 4.43005 2 7.43005V13.4301C2 16.4301 4 18.4301 7 18.4301V20.5601C7 21.3601 7.89 21.8401 8.55 21.3901L13 18.4301H17C20 18.4301 22 16.4301 22 13.4301V7.43005C22 4.43005 20 2.43005 17 2.43005ZM12 14.6001C11.58 14.6001 11.25 14.2601 11.25 13.8501C11.25 13.4401 11.58 13.1001 12 13.1001C12.42 13.1001 12.75 13.4401 12.75 13.8501C12.75 14.2601 12.42 14.6001 12 14.6001ZM13.26 10.4501C12.87 10.7101 12.75 10.8801 12.75 11.1601V11.3701C12.75 11.7801 12.41 12.1201 12 12.1201C11.59 12.1201 11.25 11.7801 11.25 11.3701V11.1601C11.25 10.0001 12.1 9.43005 12.42 9.21005C12.79 8.96005 12.91 8.79005 12.91 8.53005C12.91 8.03005 12.5 7.62005 12 7.62005C11.5 7.62005 11.09 8.03005 11.09 8.53005C11.09 8.94005 10.75 9.28005 10.34 9.28005C9.93 9.28005 9.59 8.94005 9.59 8.53005C9.59 7.20005 10.67 6.12005 12 6.12005C13.33 6.12005 14.41 7.20005 14.41 8.53005C14.41 9.67005 13.57 10.2401 13.26 10.4501Z"
      fill="#FEFEFE"
    />
  </svg>
);

export const featuresSvg = (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.8893 1.79342C22.8808 1.75196 22.8606 1.7138 22.8311 1.68342C22.8016 1.65303 22.7641 1.63168 22.7229 1.62186C19.9775 0.950607 13.6339 3.34264 10.197 6.77811C9.584 7.38615 9.02517 8.04646 8.52684 8.75154C7.46699 8.65779 6.40715 8.73608 5.50387 9.12983C2.95527 10.2515 2.21324 13.1784 2.00652 14.4375C1.9948 14.5064 1.99922 14.5771 2.01944 14.644C2.03967 14.7109 2.07514 14.7722 2.12307 14.8231C2.171 14.874 2.23009 14.9131 2.29567 14.9373C2.36126 14.9614 2.43156 14.9701 2.50106 14.9625L6.59371 14.5111C6.59663 14.8196 6.61525 15.1278 6.64949 15.4345C6.67009 15.6475 6.76462 15.8465 6.91668 15.997L8.50152 17.5781C8.65218 17.73 8.85113 17.8245 9.06402 17.8453C9.36898 17.8794 9.67547 17.898 9.98231 17.9011L9.53324 21.9886C9.52575 22.058 9.53446 22.1283 9.55867 22.1938C9.58289 22.2594 9.62196 22.3184 9.67282 22.3663C9.72368 22.4142 9.78495 22.4497 9.85182 22.47C9.91869 22.4902 9.98935 22.4947 10.0582 22.4831C11.315 22.2815 14.247 21.5395 15.3621 18.9909C15.7559 18.0876 15.8365 17.033 15.7456 15.9783C16.4524 15.4799 17.1144 14.9209 17.7242 14.3076C21.1718 10.8773 23.5503 4.67529 22.8893 1.79342ZM14.2845 10.2155C13.9697 9.90084 13.7552 9.49993 13.6683 9.06344C13.5814 8.62694 13.6258 8.17446 13.7961 7.76324C13.9663 7.35202 14.2547 7.00053 14.6248 6.75324C14.9948 6.50594 15.4299 6.37394 15.875 6.37394C16.32 6.37394 16.7551 6.50594 17.1251 6.75324C17.4952 7.00053 17.7836 7.35202 17.9538 7.76324C18.1241 8.17446 18.1686 8.62694 18.0816 9.06344C17.9947 9.49993 17.7802 9.90084 17.4654 10.2155C17.2567 10.4245 17.0088 10.5904 16.7358 10.7035C16.4629 10.8167 16.1704 10.8749 15.875 10.8749C15.5795 10.8749 15.287 10.8167 15.0141 10.7035C14.7412 10.5904 14.4932 10.4245 14.2845 10.2155Z"
      fill="#FEFEFE"
    />
    <path
      d="M8.39375 18.7233C8.13687 18.9806 7.72484 19.0809 7.22891 19.1667C6.11469 19.3566 5.13078 18.3938 5.33094 17.2673C5.40734 16.8403 5.63328 16.2417 5.77391 16.1011C5.80464 16.071 5.8251 16.0319 5.83238 15.9895C5.83965 15.947 5.83337 15.9034 5.81443 15.8647C5.79549 15.8261 5.76485 15.7943 5.72686 15.7741C5.68887 15.7538 5.64547 15.7461 5.60281 15.7519C4.97973 15.8281 4.40006 16.1106 3.95609 16.5544C2.85406 17.6573 2.75 21.75 2.75 21.75C2.75 21.75 6.845 21.6459 7.94703 20.543C8.39218 20.0994 8.67503 19.5188 8.75 18.8948C8.76734 18.6989 8.52875 18.5822 8.39375 18.7233Z"
      fill="#FEFEFE"
    />
  </svg>
);

export const BulletSvg = ({ fill, gradientId, gradientColors }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {gradientId && gradientColors && (
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            {gradientColors.map((color, index) => (
              <stop
                key={index}
                offset={`${index * 100}%`}
                style={{ stopColor: color }}
              />
            ))}
          </linearGradient>
        )}
      </defs>
      <path
        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
        fill={gradientId ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};
export const githubSvg = (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5962 1.5C6.79775 1.5 2.09619 6.31875 2.09619 12.2672C2.09619 17.025 5.10557 21.0562 9.27744 22.4813C9.80244 22.5797 9.99463 22.2469 9.99463 21.9609C9.99463 21.7031 9.98525 21.0281 9.98057 20.1281C7.06025 20.7797 6.4415 18.6844 6.4415 18.6844C5.96338 17.4422 5.27432 17.1094 5.27432 17.1094C4.32275 16.4391 5.34463 16.4531 5.34463 16.4531C6.39932 16.5281 6.95244 17.5641 6.95244 17.5641C7.88994 19.2094 9.40869 18.7359 10.0087 18.4594C10.1024 17.7656 10.3743 17.2875 10.6743 17.0203C8.34463 16.7484 5.89307 15.825 5.89307 11.7C5.89307 10.5234 6.30088 9.5625 6.97119 8.8125C6.86338 8.54063 6.50244 7.44375 7.07432 5.9625C7.07432 5.9625 7.95557 5.67188 9.96182 7.06406C10.8009 6.825 11.6962 6.70781 12.5915 6.70312C13.4821 6.70781 14.3821 6.825 15.2212 7.06406C17.2274 5.67188 18.104 5.9625 18.104 5.9625C18.6759 7.44375 18.3149 8.54063 18.2071 8.8125C18.8774 9.56719 19.2853 10.5281 19.2853 11.7C19.2853 15.8344 16.829 16.7437 14.4899 17.0109C14.8649 17.3438 15.2024 18 15.2024 19.0031C15.2024 20.4422 15.1884 21.6047 15.1884 21.9562C15.1884 22.2422 15.3759 22.5797 15.9103 22.4719C20.0915 21.0516 23.0962 17.0203 23.0962 12.2672C23.0962 6.31875 18.3946 1.5 12.5962 1.5Z"
      fill="#FEFEFE"
    />
  </svg>
);
export const downloadSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.98999 8.76001L8.90999 10.68L10.83 8.76001"
      stroke="#121212"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.91 3V10.6275"
      stroke="#121212"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 9.13501C15 12.45 12.75 15.135 9 15.135C5.25 15.135 3 12.45 3 9.13501"
      stroke="#121212"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const copyToClipboardSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.75 10.05V12.3C12.75 15.3 11.55 16.5 8.55 16.5H5.7C2.7 16.5 1.5 15.3 1.5 12.3V9.45C1.5 6.45 2.7 5.25 5.7 5.25H7.95"
      stroke="#FDFDFD"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.75 10.05H10.35C8.55 10.05 7.95 9.45 7.95 7.65V5.25L12.75 10.05Z"
      stroke="#FDFDFD"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.7 1.5H11.7"
      stroke="#FDFDFD"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 3.75C5.25 2.505 6.255 1.5 7.5 1.5H9.465"
      stroke="#FDFDFD"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 6V10.6425C16.5 11.805 15.555 12.75 14.3925 12.75"
      stroke="#FDFDFD"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 6H14.25C12.5625 6 12 5.4375 12 3.75V1.5L16.5 6Z"
      stroke="#FDFDFD"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const primaryDownloadSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.98999 8.76001L8.90999 10.68L10.83 8.76001"
      stroke="#FDD649"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.91003 3V10.6275"
      stroke="#FDD649"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 9.13501C15 12.45 12.75 15.135 9 15.135C5.25 15.135 3 12.45 3 9.13501"
      stroke="#FDD649"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const resumeDownloadSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.98999 8.76001L8.90999 10.68L10.83 8.76001"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.91003 3V10.6275"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 9.13501C15 12.45 12.75 15.135 9 15.135C5.25 15.135 3 12.45 3 9.13501"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const attachmentSvg = (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2425 13.625H12.375C14.64 13.625 16.5 11.7725 16.5 9.5C16.5 7.235 14.6475 5.375 12.375 5.375H11.2425"
      stroke="#676767"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 5.375H5.625C3.3525 5.375 1.5 7.2275 1.5 9.5C1.5 11.765 3.3525 13.625 5.625 13.625H6.75"
      stroke="#676767"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 9.5H12"
      stroke="#676767"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const contactSvg = (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2803 10.7803L15.2664 12.7664C15.5335 13.0335 15.5335 13.4665 15.2664 13.7336C13.8225 15.1775 11.5366 15.3399 9.90299 14.1147L8.72143 13.2286C7.41378 12.2478 6.25216 11.0862 5.27143 9.77857L4.38526 8.59701C3.16005 6.96341 3.32251 4.67749 4.76642 3.23358C5.0335 2.9665 5.4665 2.9665 5.73358 3.23358L7.71967 5.21967C8.01256 5.51256 8.01256 5.98744 7.71967 6.28033L6.95381 7.04619C6.8321 7.1679 6.80192 7.35384 6.8789 7.5078C7.7689 9.28779 9.21221 10.7311 10.9922 11.6211C11.1462 11.6981 11.3321 11.6679 11.4538 11.5462L12.2197 10.7803C12.5126 10.4874 12.9874 10.4874 13.2803 10.7803Z"
      stroke="#676767"
      strokeWidth="0.75"
    />
  </svg>
);

export const freelanceProjects = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM9.94 13.27C9.26 14.29 8.32 15.12 7.22 15.67C7.12 15.72 7 15.75 6.89 15.75C6.61 15.75 6.35 15.6 6.22 15.34C6.03 14.97 6.18 14.52 6.56 14.33C7.43 13.9 8.17 13.24 8.7 12.44C8.88 12.17 8.88 11.83 8.7 11.56C8.16 10.76 7.42 10.1 6.56 9.67C6.18 9.49 6.03 9.04 6.22 8.66C6.4 8.29 6.85 8.14 7.22 8.33C8.32 8.88 9.26 9.71 9.94 10.73C10.46 11.5 10.46 12.5 9.94 13.27ZM17 15.75H13C12.59 15.75 12.25 15.41 12.25 15C12.25 14.59 12.59 14.25 13 14.25H17C17.41 14.25 17.75 14.59 17.75 15C17.75 15.41 17.41 15.75 17 15.75Z"
      fill="currentColor"
    />
  </svg>
);

export const nichesSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.6702 6.9499C21.0302 4.7799 19.2202 2.9699 17.0502 2.3299C15.4002 1.8499 14.2602 1.8899 13.4702 2.4799C12.5202 3.1899 12.4102 4.4699 12.4102 5.3799V7.8699C12.4102 10.3299 13.5302 11.5799 15.7302 11.5799H18.6002C19.5002 11.5799 20.7902 11.4699 21.5002 10.5199C22.1102 9.7399 22.1602 8.5999 21.6702 6.9499Z"
      fill="currentColor"
    />
    <path
      d="M18.9099 13.3599C18.6499 13.0599 18.2699 12.8899 17.8799 12.8899H14.2999C12.5399 12.8899 11.1099 11.4599 11.1099 9.69991V6.11991C11.1099 5.72991 10.9399 5.34991 10.6399 5.08991C10.3499 4.82991 9.9499 4.70991 9.5699 4.75991C7.2199 5.05991 5.0599 6.34991 3.6499 8.28991C2.2299 10.2399 1.7099 12.6199 2.1599 14.9999C2.8099 18.4399 5.5599 21.1899 9.0099 21.8399C9.5599 21.9499 10.1099 21.9999 10.6599 21.9999C12.4699 21.9999 14.2199 21.4399 15.7099 20.3499C17.6499 18.9399 18.9399 16.7799 19.2399 14.4299C19.2899 14.0399 19.1699 13.6499 18.9099 13.3599Z"
      fill="currentColor"
    />
  </svg>
);

export const proposalSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8002 2.20999C15.3902 1.79999 14.6802 2.07999 14.6802 2.64999V6.13999C14.6802 7.59999 15.9202 8.80999 17.4302 8.80999C18.3802 8.81999 19.7002 8.81999 20.8302 8.81999C21.4002 8.81999 21.7002 8.14999 21.3002 7.74999C19.8602 6.29999 17.2802 3.68999 15.8002 2.20999Z"
      fill="currentColor"
    />
    <path
      d="M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19ZM11.5 17.75H7.5C7.09 17.75 6.75 17.41 6.75 17C6.75 16.59 7.09 16.25 7.5 16.25H11.5C11.91 16.25 12.25 16.59 12.25 17C12.25 17.41 11.91 17.75 11.5 17.75ZM13.5 13.75H7.5C7.09 13.75 6.75 13.41 6.75 13C6.75 12.59 7.09 12.25 7.5 12.25H13.5C13.91 12.25 14.25 12.59 14.25 13C14.25 13.41 13.91 13.75 13.5 13.75Z"
      fill="currentColor"
    />
  </svg>
);

export const timeSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 9C16.5 13.14 13.14 16.5 9 16.5C4.86 16.5 1.5 13.14 1.5 9C1.5 4.86 4.86 1.5 9 1.5C13.14 1.5 16.5 4.86 16.5 9Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokelinecapbox="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7825 11.385L9.4575 9.99751C9.0525 9.75751 8.7225 9.18001 8.7225 8.70751V5.63251"
      stroke="#888888"
      strokeWidth="1.5"
      strokelinecapbox="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const credentialSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.625 13.5V5.25C2.625 2.25 3.375 1.5 6.375 1.5H11.625C14.625 1.5 15.375 2.25 15.375 5.25V12.75C15.375 12.855 15.375 12.96 15.3675 13.065"
      stroke="#888888"
      strokeWidth="1.5"
      strokelinecapbox="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.7625 11.25H15.375V13.875C15.375 15.3225 14.1975 16.5 12.75 16.5H5.25C3.8025 16.5 2.625 15.3225 2.625 13.875V13.3875C2.625 12.21 3.585 11.25 4.7625 11.25Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokelinecapbox="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 5.25H12"
      stroke="#888888"
      strokeWidth="1.5"
      strokelinecapbox="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 7.875H9.75"
      stroke="#888888"
      strokeWidth="1.5"
      strokelinecapbox="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const editIcon = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="28" height="28" rx="4" fill="#292929" />
    <path
      d="M13.25 6.5H11.75C8 6.5 6.5 8 6.5 11.75V16.25C6.5 20 8 21.5 11.75 21.5H16.25C20 21.5 21.5 20 21.5 16.25V14.75"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokelinecapbox="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.03 7.26501L11.12 13.175C10.895 13.4 10.67 13.8425 10.625 14.165L10.3025 16.4225C10.1825 17.24 10.76 17.81 11.5775 17.6975L13.835 17.375C14.15 17.33 14.5925 17.105 14.825 16.88L20.735 10.97C21.755 9.95001 22.235 8.76501 20.735 7.26501C19.235 5.76501 18.05 6.24501 17.03 7.26501Z"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokelinecapbox="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1825 8.1125C16.685 9.905 18.0875 11.3075 19.8875 11.8175"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokelinecapbox="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const emptyStateAlert = (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="44" height="44" rx="22" fill="#292929" />
    <path
      d="M22 32C27.5 32 32 27.5 32 22C32 16.5 27.5 12 22 12C16.5 12 12 16.5 12 22C12 27.5 16.5 32 22 32Z"
      stroke="#B7B7B7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 18V23"
      stroke="#B7B7B7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9941 26H22.0031"
      stroke="#B7B7B7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const searchSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
      stroke="#414141"
      strokeWidth="1.5"
      strokelinecapbox="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 22L20 20"
      stroke="#414141"
      strokeWidth="1.5"
      strokelinecapbox="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const uploadIconSvg = (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="44" height="44" rx="22" fill="#292929" />
    <path
      d="M19.32 16.4999L21.88 13.9399L24.44 16.4999"
      stroke="#B7B7B7"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.88 24.1798V14.0098"
      stroke="#B7B7B7"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 22C14 26.42 17 30 22 30C27 30 30 26.42 30 22"
      stroke="#B7B7B7"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const emptyPortfolio = (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="44" height="44" rx="22" fill="#292929" />
    <path
      d="M31 17V27C31 30 29.5 32 26 32H18C14.5 32 13 30 13 27V17C13 14 14.5 12 18 12H26C29.5 12 31 14 31 17Z"
      stroke="#B7B7B7"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.5 14.5V16.5C24.5 17.6 25.4 18.5 26.5 18.5H28.5"
      stroke="#B7B7B7"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 23L18 25L20 27"
      stroke="#B7B7B7"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 23L26 25L24 27"
      stroke="#B7B7B7"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const portfolioProjectSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 7.5V11.25C16.5 15 15 16.5 11.25 16.5H6.75C3 16.5 1.5 15 1.5 11.25V6.75C1.5 3 3 1.5 6.75 1.5H10.5"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 7.5H13.5C11.25 7.5 10.5 6.75 10.5 4.5V1.5L16.5 7.5Z"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 9.75H9.75"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 12.75H8.25"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const portfolioImgSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V6.75C16.5 3 15 1.5 11.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5Z"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 7.5C7.57843 7.5 8.25 6.82843 8.25 6C8.25 5.17157 7.57843 4.5 6.75 4.5C5.92157 4.5 5.25 5.17157 5.25 6C5.25 6.82843 5.92157 7.5 6.75 7.5Z"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.00244 14.2124L5.69994 11.7299C6.29244 11.3324 7.14744 11.3774 7.67994 11.8349L7.92744 12.0524C8.51244 12.5549 9.45744 12.5549 10.0424 12.0524L13.1624 9.37492C13.7474 8.87242 14.6924 8.87242 15.2774 9.37492L16.4999 10.4249"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const portfolioLinkSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2427 13.125H12.3752C14.6402 13.125 16.5002 11.2725 16.5002 9C16.5002 6.735 14.6477 4.875 12.3752 4.875H11.2427"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 4.875H5.625C3.3525 4.875 1.5 6.7275 1.5 9C1.5 11.265 3.3525 13.125 5.625 13.125H6.75"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 9H12"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const customizeSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 6.5H16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 6.5H2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 10C11.933 10 13.5 8.433 13.5 6.5C13.5 4.567 11.933 3 10 3C8.067 3 6.5 4.567 6.5 6.5C6.5 8.433 8.067 10 10 10Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 17.5H18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 17.5H2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 21C15.933 21 17.5 19.433 17.5 17.5C17.5 15.567 15.933 14 14 14C12.067 14 10.5 15.567 10.5 17.5C10.5 19.433 12.067 21 14 21Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const customizeHint = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.06241 1.83725C8.58741 1.39475 9.43491 1.39475 9.94491 1.83725L11.1299 2.84975C11.3549 3.03725 11.7824 3.19475 12.0824 3.19475H13.3574C14.1524 3.19475 14.8049 3.84725 14.8049 4.64225V5.91725C14.8049 6.21725 14.9624 6.63725 15.1499 6.86225L16.1624 8.04725C16.6049 8.57225 16.6049 9.41975 16.1624 9.92975L15.1499 11.1147C14.9624 11.3397 14.8049 11.7597 14.8049 12.0597V13.3347C14.8049 14.1297 14.1524 14.7822 13.3574 14.7822H12.0824C11.7824 14.7822 11.3624 14.9397 11.1374 15.1272L9.95241 16.1397C9.42741 16.5822 8.57991 16.5822 8.06991 16.1397L6.88491 15.1272C6.65991 14.9397 6.23241 14.7822 5.93991 14.7822H4.62741C3.83241 14.7822 3.17991 14.1297 3.17991 13.3347V12.0522C3.17991 11.7597 3.02991 11.3322 2.84241 11.1147L1.82991 9.92225C1.39491 9.40475 1.39491 8.56475 1.82991 8.04725L2.84241 6.85475C3.02991 6.62975 3.17991 6.20975 3.17991 5.91725V4.64975C3.17991 3.85475 3.83241 3.20225 4.62741 3.20225H5.92491C6.22491 3.20225 6.64491 3.04475 6.86991 2.85725L8.06241 1.83725Z"
      stroke="#888888"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 6.09766V9.72016"
      stroke="#888888"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.99585 12H9.00259"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const preferencesSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 7.5L4.5 9L6 10.5"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 7.5L13.5 9L12 10.5"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 7.25244L8.25 10.7475"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const dollarSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.50391 10.7474C6.50391 11.7149 7.24641 12.4949 8.16891 12.4949H10.0514C10.8539 12.4949 11.5064 11.8124 11.5064 10.9724C11.5064 10.0574 11.1089 9.73488 10.5164 9.52488L7.49391 8.47488C6.90141 8.26488 6.50391 7.94238 6.50391 7.02738C6.50391 6.18738 7.15641 5.50488 7.95891 5.50488H9.84141C10.7639 5.50488 11.5064 6.28488 11.5064 7.25238"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 4.5V13.5"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
      stroke="#B7B7B7"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const deleteSvg = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="28" height="28" rx="4" fill="#292929" />
    <path
      d="M20.75 9.48486C18.2525 9.23736 15.74 9.10986 13.235 9.10986C11.75 9.10986 10.265 9.18486 8.78 9.33486L7.25 9.48486"
      stroke="#FC9D9C"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.375 8.7275L11.54 7.745C11.66 7.0325 11.75 6.5 13.0175 6.5H14.9825C16.25 6.5 16.3475 7.0625 16.46 7.7525L16.625 8.7275"
      stroke="#FC9D9C"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1373 11.855L18.6498 19.4075C18.5673 20.585 18.4998 21.5 16.4073 21.5H11.5923C9.4998 21.5 9.4323 20.585 9.3498 19.4075L8.8623 11.855"
      stroke="#FC9D9C"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7476 17.375H15.2451"
      stroke="#FC9D9C"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.125 14.375H15.875"
      stroke="#FC9D9C"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const expandIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 9V3H15"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 15V21H9"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 3L13.5 10.5"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 13.5L3 21"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const goDeeper = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 4.84969V16.7397C22 17.7097 21.21 18.5997 20.24 18.7197L19.93 18.7597C18.29 18.9797 15.98 19.6597 14.12 20.4397C13.47 20.7097 12.75 20.2197 12.75 19.5097V5.59969C12.75 5.22969 12.96 4.88969 13.29 4.70969C15.12 3.71969 17.89 2.83969 19.77 2.67969H19.83C21.03 2.67969 22 3.64969 22 4.84969Z"
      fill="#FEFEFE"
    />
    <path
      d="M10.71 4.70969C8.87999 3.71969 6.10999 2.83969 4.22999 2.67969H4.15999C2.95999 2.67969 1.98999 3.64969 1.98999 4.84969V16.7397C1.98999 17.7097 2.77999 18.5997 3.74999 18.7197L4.05999 18.7597C5.69999 18.9797 8.00999 19.6597 9.86999 20.4397C10.52 20.7097 11.24 20.2197 11.24 19.5097V5.59969C11.24 5.21969 11.04 4.88969 10.71 4.70969ZM4.99999 7.73969H7.24999C7.65999 7.73969 7.99999 8.07969 7.99999 8.48969C7.99999 8.90969 7.65999 9.23969 7.24999 9.23969H4.99999C4.58999 9.23969 4.24999 8.90969 4.24999 8.48969C4.24999 8.07969 4.58999 7.73969 4.99999 7.73969ZM7.99999 12.2397H4.99999C4.58999 12.2397 4.24999 11.9097 4.24999 11.4897C4.24999 11.0797 4.58999 10.7397 4.99999 10.7397H7.99999C8.40999 10.7397 8.74999 11.0797 8.74999 11.4897C8.74999 11.9097 8.40999 12.2397 7.99999 12.2397Z"
      fill="#FEFEFE"
    />
  </svg>
);

export const questionLink = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2599 22.0004C15.1999 22.0004 15.1299 21.9904 15.0699 21.9704C13.0599 21.4004 10.9499 21.4004 8.93991 21.9704C8.56991 22.0704 8.17991 21.8604 8.07991 21.4904C7.96991 21.1204 8.18991 20.7304 8.55991 20.6304C10.8199 19.9904 13.1999 19.9904 15.4599 20.6304C15.8299 20.7404 16.0499 21.1204 15.9399 21.4904C15.8399 21.8004 15.5599 22.0004 15.2599 22.0004Z"
      fill="#FEFEFE"
    />
    <path
      d="M19.21 6.35952C18.17 4.25952 16.16 2.70952 13.83 2.19952C11.39 1.65952 8.88997 2.23952 6.97997 3.77952C5.05997 5.30952 3.96997 7.59952 3.96997 10.0495C3.96997 12.6395 5.51997 15.3495 7.85997 16.9195V17.7495C7.84997 18.0295 7.83997 18.4595 8.17997 18.8095C8.52997 19.1695 9.04997 19.2095 9.45997 19.2095H14.59C15.13 19.2095 15.54 19.0595 15.82 18.7795C16.2 18.3895 16.19 17.8895 16.18 17.6195V16.9195C19.28 14.8295 21.23 10.4195 19.21 6.35952ZM13.72 11.6195L12.65 13.4795C12.51 13.7195 12.26 13.8595 12 13.8595C11.87 13.8595 11.74 13.8295 11.63 13.7595C11.27 13.5495 11.15 13.0895 11.35 12.7395L12.2 11.2595H11.36C10.86 11.2595 10.45 11.0395 10.23 10.6695C10.01 10.2895 10.03 9.82952 10.28 9.38952L11.35 7.52952C11.56 7.16952 12.02 7.04952 12.37 7.24952C12.73 7.45952 12.85 7.91952 12.65 8.26952L11.8 9.74952H12.64C13.14 9.74952 13.55 9.96952 13.77 10.3395C13.99 10.7195 13.97 11.1895 13.72 11.6195Z"
      fill="#FEFEFE"
    />
  </svg>
);

export const tublibotIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.375"
      y="0.375"
      width="23.25"
      height="23.25"
      rx="11.625"
      stroke="url(#paint0_linear_14096_7575)"
      strokeWidth="0.75"
    />
    <g opacity="0.3">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.0278 14.0488C7.0278 14.0488 7.2999 15.302 8.93109 15.3731C8.79039 16.0473 8.46603 16.7242 8.35876 17.318C8.32258 17.5123 8.13364 18.5819 7.49561 18.8781C6.85758 19.1729 6.27721 17.6838 6.39655 16.9159C6.39644 16.9158 7.06927 14.6573 7.0278 14.0488Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.02795 14.0488C7.02795 14.0488 7.30005 15.302 8.93124 15.3731C8.82936 15.8623 8.631 16.3516 8.48893 16.81C8.44471 16.0862 8.29861 15.7149 8.29861 15.7149C7.6499 15.5809 7.21562 15.2485 6.9248 14.8665C6.99579 14.5205 7.04001 14.2203 7.02795 14.0488Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.5185 14.0488C18.5185 14.0488 18.2464 15.302 16.6152 15.3731C16.7573 16.0473 17.0803 16.7242 17.1889 17.318C17.2237 17.5123 17.4128 18.5819 18.0521 18.8781C18.6901 19.1729 19.2691 17.6838 19.1512 16.9159C19.1513 16.9158 18.4771 14.6573 18.5185 14.0488Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.5185 14.0488C18.5185 14.0488 18.2464 15.302 16.6152 15.3731C16.7185 15.8623 16.9168 16.3516 17.0589 16.81C17.1031 16.0862 17.2479 15.7149 17.2479 15.7149C17.898 15.5809 18.3322 15.2485 18.6217 14.8665C18.5521 14.5205 18.5065 14.2203 18.5185 14.0488Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.2588 12.2898C16.2588 12.2898 18.2666 11.9307 18.6164 13.4841C18.9663 15.0375 17.2828 15.6541 16.555 15.4611C16.555 15.4611 15.2361 13.0606 15.2629 12.9574C15.2897 12.8541 16.2588 12.2898 16.2588 12.2898Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.28782 12.2898C9.28782 12.2898 7.28139 11.9307 6.93154 13.4841C6.58168 15.0375 8.26514 15.6541 8.99161 15.4611C8.99161 15.4611 10.3119 13.0606 10.285 12.9574C10.2581 12.8541 9.28782 12.2898 9.28782 12.2898Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.522 12.5713C10.522 12.5713 8.94982 13.0431 8.9605 14.7346C8.96315 15.0335 8.99668 15.4263 9.0664 15.8686C9.38674 17.918 10.4737 21.0383 12.7737 20.9993C15.0724 21.0382 16.1608 17.918 16.4811 15.8686C16.5508 15.4263 16.5843 15.0336 16.5856 14.7346C16.5977 13.0431 15.0255 12.5713 15.0255 12.5713C14.3044 13.1731 12.7737 13.0323 12.7737 13.0323C12.7737 13.0323 11.2432 13.173 10.522 12.5713Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.1482 12.7373C9.90688 12.87 9.59332 13.0924 9.34937 13.437C9.655 13.8325 10.5034 14.4892 12.7739 14.5133C15.0431 14.4892 15.8916 13.8325 16.1985 13.437C15.9545 13.0926 15.6409 12.8701 15.3997 12.7373L14.6263 12.807C13.853 13.1314 12.774 13.0321 12.774 13.0321C12.774 13.0321 11.6937 13.1314 10.9217 12.807L10.1482 12.7373Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.7739 4.80371C12.7739 4.80371 8.67109 4.89892 8.10415 7.83018C7.53722 10.7614 8.34007 13.7638 12.7739 13.8121C17.2063 13.7639 18.0105 10.7615 17.4422 7.83018C16.8753 4.89892 12.7739 4.80371 12.7739 4.80371Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.0127 7.14403C11.0127 7.14403 11.9818 7.54614 12.7739 7.38132C13.5661 7.54614 14.5351 7.14403 14.5351 7.14403C15.1503 6.80222 17.2065 7.29817 16.5215 9.82742C15.8352 12.3579 12.7739 12.2749 12.7739 12.2749C12.7739 12.2749 9.71266 12.358 9.02639 9.82742C8.3415 7.29817 10.3975 6.80222 11.0127 7.14403Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.7738 4.80371C12.7738 4.80371 12.0473 4.82117 11.1641 5.05835C11.3303 5.58508 11.7056 6.4751 12.3596 6.54207H12.7738H13.1866C13.8407 6.4751 14.2173 5.58508 14.3835 5.05835C13.5002 4.82117 12.7738 4.80371 12.7738 4.80371Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.1514 17.1751C17.1701 17.2395 17.1835 17.2891 17.1889 17.3172L17.1929 17.3387C17.41 17.2047 17.9341 17.0037 19.1552 16.946C19.1538 16.9353 19.1525 16.9259 19.1511 16.9152C19.1511 16.9152 19.1297 16.8455 19.0962 16.7275C18.5279 16.7355 17.6742 16.8132 17.1514 17.1751Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.4154 7.70117C17.7009 7.82315 18.1875 8.08456 18.1875 8.33782C18.1875 8.33782 18.5386 10.8898 17.4114 10.9019C17.6741 9.965 17.6487 8.8927 17.4422 7.82981C17.4342 7.78559 17.4248 7.74275 17.4154 7.70117Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.2372 9.33398C18.2185 10.051 18.059 10.8955 17.4116 10.9021C17.5256 10.496 17.5859 10.0631 17.5993 9.61676C17.8673 9.54049 18.075 9.43988 18.2372 9.33398Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.2534 7.72452C17.2534 7.72452 17.2896 5.5612 15.5633 4.59078C15.5633 4.59078 14.4884 4.62696 14.5943 3.84685C14.7002 3.06675 15.8233 3.75164 15.8595 4.12434C15.83 4.28387 18.6139 6.48338 17.3955 8.2083L17.2534 7.72452Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.4813 15.8691C16.4732 15.9188 16.4652 15.9684 16.4571 16.0193C15.5711 16.3824 14.4467 16.4763 14.4467 16.4763C14.3287 18.3568 12.7739 18.1718 12.7739 18.1718V18.0739C14.4761 18.0271 14.3461 16.3007 14.3461 16.3007C15.5631 16.2659 16.4813 15.8691 16.4813 15.8691Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.8716 8.41992C14.5472 8.41992 14.2805 8.68535 14.2805 9.01098V10.027C14.2805 10.3527 14.5472 10.618 14.8716 10.618C15.1973 10.618 15.4626 10.3526 15.4626 10.027V9.01098C15.4627 8.68525 15.1973 8.41992 14.8716 8.41992Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.3382 8.76038C14.302 8.83676 14.2805 8.92119 14.2805 9.011V10.027C14.2805 10.3528 14.5472 10.6181 14.8716 10.6181C14.9614 10.6181 15.0472 10.598 15.1236 10.5618C15.1597 10.4854 15.1798 10.401 15.1798 10.3112V9.29516C15.1798 8.96943 14.9131 8.7041 14.5888 8.7041C14.499 8.7041 14.4132 8.7242 14.3382 8.76038Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.3949 17.1751C8.37618 17.2395 8.36274 17.2891 8.35872 17.3172L8.3547 17.3387C8.13624 17.2047 7.61215 17.0037 6.39111 16.946C6.39249 16.9353 6.39376 16.9259 6.39651 16.9152C6.39651 16.9152 6.41661 16.8455 6.45014 16.7275C7.01972 16.7355 7.87346 16.8132 8.3949 17.1751Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.13211 7.70117C7.84658 7.82315 7.36005 8.08456 7.36005 8.33782C7.36005 8.33782 7.00755 10.8898 8.13476 10.9019H8.13613C7.87345 9.965 7.89884 8.8927 8.10397 7.82981C8.11201 7.78559 8.12143 7.74275 8.13211 7.70117Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.30933 9.33398C7.32805 10.051 7.48896 10.8955 8.13492 10.9021H8.1363C8.02236 10.496 7.96206 10.0631 7.94735 9.61676C7.68065 9.54049 7.4715 9.43988 7.30933 9.33398Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.29314 7.72452C8.29314 7.72452 8.25833 5.5612 9.98326 4.59078C9.98326 4.59078 11.0596 4.62696 10.9537 3.84685C10.8464 3.06675 9.72322 3.75164 9.68842 4.12434C9.71793 4.28387 6.93404 6.48338 8.15106 8.2083L8.29314 7.72452Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.06641 15.8691C9.07307 15.9188 9.08111 15.9684 9.09053 16.0193C9.97653 16.3824 11.101 16.4763 11.101 16.4763C11.2189 18.3568 12.7738 18.1718 12.7738 18.1718V18.0739C11.0716 18.0271 11.2016 16.3007 11.2016 16.3007C9.98319 16.2659 9.06641 15.8691 9.06641 15.8691Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.10547 16.1016C9.46865 18.1456 10.5598 21.0367 12.774 20.9992C14.9869 21.0367 16.078 18.1456 16.4425 16.1016C16.0833 16.9728 14.9118 19.3479 12.774 19.368C10.6361 19.3479 9.46325 16.9729 9.10547 16.1016Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.7739 15.083C13.5218 15.083 14.1276 15.6889 14.1276 16.4367C14.1276 17.1833 13.5217 17.7891 12.7739 17.7891C12.0259 17.7891 11.4202 17.1833 11.4202 16.4367C11.4202 15.6889 12.026 15.083 12.7739 15.083Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.774 15.083C13.4281 15.083 13.9735 15.5468 14.0995 16.1646C13.9735 16.7812 13.4281 17.2462 12.774 17.2462C12.1199 17.2462 11.573 16.7812 11.447 16.1646C11.573 15.5468 12.12 15.083 12.774 15.083Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6748 8.41992C11.0005 8.41992 11.2659 8.68535 11.2659 9.01098V10.027C11.2659 10.3527 11.0004 10.618 10.6748 10.618C10.3504 10.618 10.0837 10.3526 10.0837 10.027V9.01098C10.0836 8.68525 10.3504 8.41992 10.6748 8.41992Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.2098 8.76038C11.246 8.83676 11.2661 8.92119 11.2661 9.011V10.027C11.2661 10.3528 11.0007 10.6181 10.6751 10.6181C10.5852 10.6181 10.5008 10.598 10.4244 10.5618C10.3883 10.4854 10.3682 10.401 10.3682 10.3112V9.29516C10.3682 8.96943 10.6336 8.7041 10.9592 8.7041C11.049 8.7041 11.1335 8.7242 11.2098 8.76038Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.3665 5.58828C11.5755 6.03863 11.8986 6.49565 12.3596 6.54262H12.7738H13.1866C13.649 6.49576 13.972 6.03863 14.1811 5.58828C13.5766 5.4261 13.0459 5.36718 12.7738 5.3457C12.5004 5.36707 11.9709 5.4261 11.3665 5.58828Z"
        fill="black"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.64694 13.5586C6.64694 13.5586 6.91904 14.8118 8.55023 14.8829C8.40953 15.5571 8.08517 16.2339 7.9779 16.8278C7.94172 17.0221 7.75278 18.0916 7.11475 18.3879C6.47673 18.6827 5.89635 17.1936 6.01569 16.4256C6.01558 16.4255 6.68841 14.1671 6.64694 13.5586Z"
      fill="#E0E0F0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.64709 13.5586C6.64709 13.5586 6.91919 14.8118 8.55038 14.8829C8.4485 15.3721 8.25014 15.8613 8.10807 16.3197C8.06385 15.5959 7.91775 15.2247 7.91775 15.2247C7.26904 15.0907 6.83477 14.7583 6.54395 14.3763C6.61493 14.0304 6.65915 13.7302 6.64709 13.5586Z"
      fill="#9596CA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.1377 13.5586C18.1377 13.5586 17.8656 14.8118 16.2344 14.8829C16.3765 15.5571 16.6994 16.2339 16.8081 16.8278C16.8429 17.0221 17.0319 18.0916 17.6712 18.3879C18.3093 18.6827 18.8883 17.1936 18.7703 16.4256C18.7704 16.4255 18.0962 14.1671 18.1377 13.5586Z"
      fill="#E0E0F0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.1377 13.5586C18.1377 13.5586 17.8656 14.8118 16.2344 14.8829C16.3376 15.3721 16.536 15.8613 16.6781 16.3197C16.7223 15.5959 16.867 15.2247 16.867 15.2247C17.5171 15.0907 17.9514 14.7583 18.2408 14.3763C18.1712 14.0304 18.1256 13.7302 18.1377 13.5586Z"
      fill="#9596CA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.8777 11.7996C15.8777 11.7996 17.8855 11.4404 18.2353 12.9939C18.5852 14.5473 16.9017 15.1638 16.1739 14.9709C16.1739 14.9709 14.855 12.5704 14.8817 12.4671C14.9086 12.3639 15.8777 11.7996 15.8777 11.7996Z"
      fill="#1D2949"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.90672 11.7996C8.90672 11.7996 6.90028 11.4404 6.55043 12.9939C6.20058 14.5473 7.88403 15.1638 8.6105 14.9709C8.6105 14.9709 9.93078 12.5704 9.9039 12.4671C9.87714 12.3639 8.90672 11.7996 8.90672 11.7996Z"
      fill="#1D2949"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.1411 12.082C10.1411 12.082 8.56896 12.5539 8.57964 14.2454C8.58229 14.5442 8.61582 14.937 8.68554 15.3793C9.00588 17.4287 10.0929 20.549 12.3929 20.5101C14.6915 20.5489 15.7799 17.4287 16.1002 15.3793C16.1699 14.937 16.2035 14.5443 16.2048 14.2454C16.2168 12.5539 14.6446 12.082 14.6446 12.082C13.9236 12.6839 12.3929 12.5431 12.3929 12.5431C12.3929 12.5431 10.8623 12.6839 10.1411 12.082Z"
      fill="#E0E0F0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.76733 12.248C9.52603 12.3807 9.21246 12.6032 8.96851 12.9477C9.27414 13.3432 10.1226 13.9999 12.3931 14.0241C14.6623 13.9999 15.5107 13.3432 15.8176 12.9477C15.5737 12.6033 15.26 12.3808 15.0188 12.248L14.2455 12.3178C13.4721 12.6421 12.3932 12.5429 12.3932 12.5429C12.3932 12.5429 11.3128 12.6421 10.5409 12.3178L9.76733 12.248Z"
      fill="#9596CA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3928 4.31445C12.3928 4.31445 8.28998 4.40967 7.72305 7.34092C7.15611 10.2722 7.95896 13.2745 12.3928 13.3229C16.8252 13.2746 17.6294 10.2723 17.0611 7.34092C16.4942 4.40967 12.3928 4.31445 12.3928 4.31445Z"
      fill="#E0E0F0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.6316 6.65477C10.6316 6.65477 11.6007 7.05688 12.3928 6.89206C13.185 7.05688 14.154 6.65477 14.154 6.65477C14.7692 6.31296 16.8254 6.80891 16.1404 9.33816C15.4541 11.8687 12.3928 11.7856 12.3928 11.7856C12.3928 11.7856 9.33155 11.8688 8.64529 9.33816C7.96039 6.80891 10.0164 6.31296 10.6316 6.65477Z"
      fill="#2A317D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3929 4.31445C12.3929 4.31445 11.6665 4.33191 10.7832 4.56909C10.9494 5.09583 11.3247 5.98585 11.9787 6.05281H12.3929H12.8057C13.4598 5.98585 13.8364 5.09583 14.0026 4.56909C13.1194 4.33191 12.3929 4.31445 12.3929 4.31445Z"
      fill="#20B4E8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.7703 16.6859C16.789 16.7502 16.8024 16.7998 16.8078 16.828L16.8118 16.8494C17.0289 16.7154 17.553 16.5144 18.7741 16.4567C18.7727 16.4461 18.7714 16.4366 18.77 16.426C18.77 16.426 18.7486 16.3562 18.7151 16.2383C18.1468 16.2463 17.2931 16.324 16.7703 16.6859Z"
      fill="#252667"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.0343 7.21191C17.3198 7.33389 17.8064 7.5953 17.8064 7.84856C17.8064 7.84856 18.1575 10.4006 17.0303 10.4126C17.293 9.47574 17.2676 8.40344 17.0611 7.34056C17.0531 7.29634 17.0437 7.25349 17.0343 7.21191Z"
      fill="#20B4E8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.8561 8.84473C17.8374 9.56178 17.6779 10.4062 17.0305 10.4129C17.1445 10.0067 17.2048 9.57384 17.2182 9.12751C17.4862 9.05112 17.6939 8.95062 17.8561 8.84473Z"
      fill="#243E8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.8723 7.23526C16.8723 7.23526 16.9085 5.07194 15.1822 4.10152C15.1822 4.10152 14.1073 4.1377 14.2132 3.35759C14.319 2.57749 15.4422 3.26238 15.4784 3.63508C15.4489 3.79462 18.2328 5.99412 17.0144 7.71904L16.8723 7.23526Z"
      fill="#1D2949"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.1004 15.3789C16.0924 15.4285 16.0843 15.4781 16.0763 15.529C15.1903 15.8922 14.0658 15.986 14.0658 15.986C13.9479 17.8665 12.3931 17.6816 12.3931 17.6816V17.5837C14.0952 17.5368 13.9652 15.8104 13.9652 15.8104C15.1822 15.7756 16.1004 15.3789 16.1004 15.3789Z"
      fill="#252667"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.4905 7.93066C14.1661 7.93066 13.8994 8.19609 13.8994 8.52172V9.53774C13.8994 9.86347 14.1661 10.1288 14.4905 10.1288C14.8162 10.1288 15.0815 9.86336 15.0815 9.53774V8.52172C15.0816 8.19609 14.8162 7.93066 14.4905 7.93066Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.9571 8.27112C13.9209 8.34751 13.8994 8.43193 13.8994 8.52174V9.53776C13.8994 9.86349 14.1661 10.1288 14.4905 10.1288C14.5803 10.1288 14.6661 10.1087 14.7425 10.0725C14.7786 9.99615 14.7987 9.91173 14.7987 9.82192V8.8059C14.7987 8.48017 14.532 8.21484 14.2077 8.21484C14.1179 8.21484 14.0321 8.23494 13.9571 8.27112Z"
      fill="#50C7EB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.01404 16.6859C7.99532 16.7502 7.98188 16.7998 7.97786 16.828L7.97384 16.8494C7.75538 16.7154 7.2313 16.5144 6.01025 16.4567C6.01163 16.4461 6.0129 16.4366 6.01565 16.426C6.01565 16.426 6.03575 16.3562 6.06929 16.2383C6.63886 16.2463 7.4926 16.324 8.01404 16.6859Z"
      fill="#252667"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.75125 7.21191C7.46572 7.33389 6.97919 7.5953 6.97919 7.84856C6.97919 7.84856 6.62669 10.4006 7.7539 10.4126H7.75527C7.4926 9.47574 7.51798 8.40344 7.72311 7.34056C7.73115 7.29634 7.74057 7.25349 7.75125 7.21191Z"
      fill="#20B4E8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.92822 8.84473C6.94695 9.56178 7.10786 10.4062 7.75382 10.4129H7.75519C7.64126 10.0067 7.58095 9.57384 7.56625 9.12751C7.29955 9.05112 7.0904 8.95062 6.92822 8.84473Z"
      fill="#243E8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.91228 7.23526C7.91228 7.23526 7.87748 5.07194 9.6024 4.10152C9.6024 4.10152 10.6787 4.1377 10.5728 3.35759C10.4655 2.57749 9.34237 3.26238 9.30756 3.63508C9.33708 3.79462 6.55318 5.99412 7.7702 7.71904L7.91228 7.23526Z"
      fill="#1D2949"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.68555 15.3789C8.69221 15.4285 8.70025 15.4781 8.70967 15.529C9.59567 15.8922 10.7201 15.986 10.7201 15.986C10.8381 17.8665 12.3929 17.6816 12.3929 17.6816V17.5837C10.6907 17.5368 10.8207 15.8104 10.8207 15.8104C9.60233 15.7756 8.68555 15.3789 8.68555 15.3789Z"
      fill="#252667"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.72461 15.6123C9.08779 17.6563 10.1789 20.5475 12.3931 20.5099C14.6061 20.5475 15.6971 17.6563 16.0616 15.6123C15.7025 16.4835 14.531 18.8586 12.3931 18.8787C10.2552 18.8586 9.08239 16.4835 8.72461 15.6123Z"
      fill="#9596CA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.393 14.5938C13.141 14.5938 13.7467 15.1996 13.7467 15.9475C13.7467 16.694 13.1408 17.2999 12.393 17.2999C11.6451 17.2999 11.0393 16.694 11.0393 15.9475C11.0393 15.1996 11.6452 14.5938 12.393 14.5938Z"
      fill="#243E8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3929 14.5938C13.047 14.5938 13.5924 15.0575 13.7184 15.6754C13.5924 16.2919 13.047 16.757 12.3929 16.757C11.7387 16.757 11.1919 16.2919 11.0659 15.6754C11.1919 15.0575 11.7389 14.5938 12.3929 14.5938Z"
      fill="#1897D4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2939 7.93066C10.6197 7.93066 10.885 8.19609 10.885 8.52172V9.53774C10.885 9.86347 10.6196 10.1288 10.2939 10.1288C9.96958 10.1288 9.70288 9.86336 9.70288 9.53774V8.52172C9.70278 8.19609 9.96958 7.93066 10.2939 7.93066Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8287 8.27112C10.8649 8.34751 10.885 8.43193 10.885 8.52174V9.53776C10.885 9.86349 10.6196 10.1288 10.294 10.1288C10.2041 10.1288 10.1197 10.1087 10.0433 10.0725C10.0072 9.99615 9.98706 9.91173 9.98706 9.82192V8.8059C9.98706 8.48017 10.2525 8.21484 10.5781 8.21484C10.6679 8.21484 10.7524 8.23494 10.8287 8.27112Z"
      fill="#50C7EB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.9856 5.09805C11.1946 5.5484 11.5177 6.00542 11.9788 6.05239H12.3929H12.8057C13.2681 6.00552 13.5911 5.5484 13.8003 5.09805C13.1958 4.93587 12.665 4.87694 12.3929 4.85547C12.1196 4.87694 11.5901 4.93587 10.9856 5.09805Z"
      fill="#243E8F"
    />
    <defs>
      <linearGradient
        id="paint0_linear_14096_7575"
        x1="0"
        y1="0"
        x2="24.8395"
        y2="8.62814"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAD038" />
        <stop offset="1" stop-color="#FF33C1" />
      </linearGradient>
    </defs>
  </svg>
);

export const podcastSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4934_8119)">
      <path
        d="M2.67739 13.0125C2.64121 12.6763 2.62368 12.3383 2.62489 12C2.62014 9.91459 3.3176 7.88827 4.60489 6.24754L4.49989 6.15004C4.34136 5.98618 4.20518 5.80209 4.09489 5.60254C2.62687 7.41025 1.83163 9.67136 1.84489 12C1.84473 12.4565 1.8748 12.9125 1.93489 13.365C2.17083 13.2246 2.41942 13.1066 2.67739 13.0125Z"
        fill="#FEFEFE"
      />
      <path
        d="M21.3751 12.0001C21.3763 12.3383 21.3588 12.6763 21.3226 13.0126C21.5837 13.1048 21.835 13.2229 22.0726 13.3651C22.1377 12.9129 22.1728 12.4569 22.1776 12.0001C22.1837 9.65939 21.3749 7.38958 19.8901 5.58008C19.7771 5.78405 19.6357 5.97092 19.4701 6.13508L19.3801 6.23258C20.6786 7.87394 21.3819 9.90722 21.3751 12.0001Z"
        fill="#FEFEFE"
      />
      <path
        d="M18.9001 5.56496C19.0901 5.37885 19.2367 5.15309 19.3294 4.9038C19.4221 4.65451 19.4587 4.38783 19.4365 4.12278C19.4143 3.85773 19.3339 3.60085 19.201 3.37047C19.068 3.14008 18.8859 2.94186 18.6676 2.78996C16.6958 1.45574 14.3696 0.742676 11.9888 0.742676C9.60808 0.742676 7.28187 1.45574 5.31009 2.78996C5.09286 2.94271 4.9118 3.14126 4.77967 3.37161C4.64754 3.60196 4.56757 3.8585 4.5454 4.12313C4.52323 4.38776 4.5594 4.65403 4.65135 4.90316C4.74331 5.15229 4.88881 5.3782 5.07759 5.56496L5.35509 5.83496C5.65109 6.13199 6.04116 6.31686 6.45847 6.35791C6.87579 6.39895 7.2944 6.29363 7.64259 6.05996C8.93449 5.21086 10.4466 4.75841 11.9926 4.75841C13.5385 4.75841 15.0507 5.21086 16.3426 6.05996C16.6913 6.29223 17.1096 6.39672 17.5265 6.35571C17.9434 6.3147 18.3334 6.13071 18.6301 5.83496L18.9001 5.56496Z"
        fill="#FEFEFE"
      />
      <path
        d="M0.750003 16.8225V18.4275C0.74902 19.1399 0.98505 19.8324 1.42092 20.3959C1.85678 20.9594 2.46772 21.3619 3.1575 21.54V13.71C2.46772 13.8881 1.85678 14.2906 1.42092 14.8541C0.98505 15.4176 0.74902 16.1101 0.750003 16.8225Z"
        fill="#FEFEFE"
      />
      <path
        d="M3.96753 12.9225V22.3275C3.96949 22.5716 4.06731 22.8051 4.23989 22.9776C4.41247 23.1502 4.64597 23.248 4.89003 23.25H6.39003V12H4.89003C4.64597 12.002 4.41247 12.0998 4.23989 12.2724C4.06731 12.4449 3.96949 12.6784 3.96753 12.9225Z"
        fill="#FEFEFE"
      />
      <path
        d="M9.46509 12H7.21509V23.25H9.46509C9.58686 23.251 9.70763 23.2279 9.82042 23.182C9.93321 23.1361 10.0358 23.0683 10.1222 22.9825C10.2087 22.8967 10.2773 22.7947 10.3242 22.6823C10.371 22.5699 10.3951 22.4493 10.3951 22.3275V12.9225C10.3951 12.8008 10.371 12.6802 10.3242 12.5678C10.2773 12.4554 10.2087 12.3533 10.1222 12.2676C10.0358 12.1818 9.93321 12.114 9.82042 12.0681C9.70763 12.0222 9.58686 11.999 9.46509 12Z"
        fill="#FEFEFE"
      />
      <path
        d="M20.8425 13.71V21.54C21.5323 21.3619 22.1432 20.9594 22.5791 20.3959C23.015 19.8324 23.251 19.1399 23.25 18.4275V16.8225C23.251 16.1101 23.015 15.4176 22.5791 14.8541C22.1432 14.2906 21.5323 13.8881 20.8425 13.71Z"
        fill="#FEFEFE"
      />
      <path
        d="M19.1099 12H17.6099V23.25H19.1099C19.3539 23.248 19.5874 23.1502 19.76 22.9776C19.9326 22.8051 20.0304 22.5716 20.0324 22.3275V12.9225C20.0304 12.6784 19.9326 12.4449 19.76 12.2724C19.5874 12.0998 19.3539 12.002 19.1099 12Z"
        fill="#FEFEFE"
      />
      <path
        d="M13.605 12.9225V22.3275C13.605 22.4493 13.6291 22.5699 13.6759 22.6823C13.7227 22.7947 13.7914 22.8967 13.8778 22.9825C13.9643 23.0683 14.0669 23.1361 14.1797 23.182C14.2924 23.2279 14.4132 23.251 14.535 23.25H16.8225V12H14.535C14.4132 11.999 14.2924 12.0222 14.1797 12.0681C14.0669 12.114 13.9643 12.1818 13.8778 12.2676C13.7914 12.3533 13.7227 12.4554 13.6759 12.5678C13.6291 12.6802 13.605 12.8008 13.605 12.9225Z"
        fill="#FEFEFE"
      />
    </g>
    <defs>
      <clipPath id="clip0_4934_8119">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const pullRequestSvg = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 5C0.5 2.51472 2.51472 0.5 5 0.5H27C29.4853 0.5 31.5 2.51472 31.5 5V27C31.5 29.4853 29.4853 31.5 27 31.5H5C2.51472 31.5 0.5 29.4853 0.5 27V5Z"
      fill="#1E1E1E"
    />
    <path
      d="M0.5 5C0.5 2.51472 2.51472 0.5 5 0.5H27C29.4853 0.5 31.5 2.51472 31.5 5V27C31.5 29.4853 29.4853 31.5 27 31.5H5C2.51472 31.5 0.5 29.4853 0.5 27V5Z"
      stroke="#292929"
    />
    <path
      d="M21.25 19V11.875C21.25 11.05 20.575 10.375 19.75 10.375H16.375"
      stroke="#FEFEFE"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.25 8.5L16 10.375L18.25 12.25"
      stroke="#FEFEFE"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.75 13.75V19"
      stroke="#FEFEFE"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9375 13.375C12.2837 13.375 13.375 12.2837 13.375 10.9375C13.375 9.59131 12.2837 8.5 10.9375 8.5C9.59131 8.5 8.5 9.59131 8.5 10.9375C8.5 12.2837 9.59131 13.375 10.9375 13.375Z"
      stroke="#FEFEFE"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.75 23.5C11.9926 23.5 13 22.4926 13 21.25C13 20.0074 11.9926 19 10.75 19C9.50736 19 8.5 20.0074 8.5 21.25C8.5 22.4926 9.50736 23.5 10.75 23.5Z"
      stroke="#FEFEFE"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.25 23.5C22.4926 23.5 23.5 22.4926 23.5 21.25C23.5 20.0074 22.4926 19 21.25 19C20.0074 19 19 20.0074 19 21.25C19 22.4926 20.0074 23.5 21.25 23.5Z"
      stroke="#FEFEFE"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const tosDashboardSvg = (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8561 8.35304C11.7319 8.91336 10.4411 9.23202 9.06849 9.23202C7.69583 9.23202 6.40503 8.91336 5.28083 8.35304C4.21842 7.82345 3.31324 9.48338 4.06281 10.5901C5.2171 12.2944 7.02973 13.3927 9.06849 13.3927C11.1073 13.3927 12.9199 12.2944 14.0742 10.5901C14.8234 9.48338 13.9182 7.82378 12.8561 8.35304ZM7.46452 11.7014C7.46452 11.7014 5.9877 11.7315 5.57166 11.3154C5.15563 10.8994 5.15563 10.2245 5.57166 9.80852C5.9877 9.39248 6.66254 9.39248 7.07857 9.80852C7.49493 10.2245 7.46452 11.7014 7.46452 11.7014ZM12.565 11.3154C12.149 11.7315 10.6721 11.7014 10.6721 11.7014C10.6721 11.7014 10.642 10.2245 11.0581 9.80852C11.4741 9.39248 12.149 9.39248 12.565 9.80852C12.981 10.2245 12.981 10.8994 12.565 11.3154Z"
      fill="#FEFEFE"
    />
    <path
      d="M9.06865 0C4.06006 0 0 4.06005 0 9.06864C0 13.4477 3.10408 17.1021 7.23175 17.9513H10.9055C15.0332 17.1021 18.1373 13.448 18.1373 9.06864C18.1373 4.06038 14.0769 0 9.06865 0ZM11.1766 17.8555H6.96033V17.5019H11.1766L11.1766 17.8555ZM11.1766 17.4062H6.96033V17.0526H11.1766V17.4062ZM11.1766 16.9568H6.96033L6.96033 16.6032H11.1766V16.9568ZM11.1766 16.5074H6.96033V16.1538H11.1766V16.5074ZM15.3816 11.5817C15.282 11.5817 15.1856 11.5564 15.0937 11.5092C14.5004 13.1756 13.0394 14.5043 11.1766 15.085V15.9843H6.96033V15.085C5.09755 14.5043 3.63658 13.1756 3.04326 11.5092C2.95171 11.5564 2.85498 11.5817 2.75534 11.5817C2.1562 11.5817 1.67028 10.6716 1.67028 9.54906C1.67028 8.64032 1.98862 7.87101 2.42762 7.61091L2.42762 3.56379H2.70293L2.70293 7.51903C2.7204 7.51741 2.73787 7.51676 2.75534 7.51676C2.92648 7.51676 3.08856 7.59117 3.23252 7.72349C4.01671 6.05547 5.69702 4.79669 7.74484 4.41203C7.74484 4.41171 7.74484 4.41139 7.74484 4.41106C7.74484 3.89021 8.12108 3.4483 8.64355 3.2901L9.068 1.10155L9.49244 3.2901C10.0149 3.4483 10.3912 3.89021 10.3912 4.41106C10.3912 4.41139 10.3912 4.41171 10.3912 4.41203C12.4393 4.79669 14.1196 6.05547 14.9035 7.72349C15.017 7.61932 15.1413 7.55106 15.2729 7.52679L15.2729 3.56379H15.5482L15.5482 7.5407C16.0681 7.69146 16.4657 8.53356 16.4657 9.54938C16.4667 10.6716 15.9808 11.5817 15.3816 11.5817Z"
      fill="#FEFEFE"
    />
  </svg>
);

export const TosIconSvg = (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.142 11.1374C15.6431 11.8845 13.922 12.3094 12.0918 12.3094C10.2616 12.3094 8.54053 11.8845 7.04159 11.1374C5.62505 10.4313 4.41814 12.6445 5.41757 14.1202C6.95662 16.3925 9.37346 17.8569 12.0918 17.8569C14.8102 17.8569 17.227 16.3925 18.766 14.1202C19.765 12.6445 18.5581 10.4317 17.142 11.1374ZM9.95319 15.6018C9.95319 15.6018 7.98409 15.6419 7.42937 15.0872C6.87466 14.5325 6.87466 13.6327 7.42937 13.078C7.98409 12.5233 8.88388 12.5233 9.43859 13.078C9.99373 13.6327 9.95319 15.6018 9.95319 15.6018ZM16.7538 15.0872C16.1991 15.6419 14.23 15.6018 14.23 15.6018C14.23 15.6018 14.1899 13.6327 14.7446 13.078C15.2993 12.5233 16.1991 12.5233 16.7538 13.078C17.3085 13.6327 17.3085 14.5325 16.7538 15.0872Z"
      fill="#FEFEFE"
    />
    <path
      d="M12.0915 0C5.41341 0 0 5.4134 0 12.0915C0 17.9302 4.13878 22.8027 9.64234 23.935L14.5407 23.935C20.0443 22.8027 24.1831 17.9307 24.1831 12.0915C24.1831 5.41384 18.7692 0 12.0915 0ZM14.9022 23.8073L9.28044 23.8073V23.3359L14.9022 23.3359V23.8073ZM14.9022 23.2082L9.28044 23.2082V22.7367L14.9022 22.7367V23.2082ZM14.9022 22.6091L9.28044 22.6091V22.1376L14.9022 22.1376V22.6091ZM14.9022 22.0099L9.28044 22.0099L9.28044 21.5385L14.9022 21.5385L14.9022 22.0099ZM20.5088 15.4422C20.376 15.4422 20.2474 15.4086 20.1249 15.3456C19.3338 17.5675 17.3859 19.339 14.9022 20.1133V21.3124L9.28044 21.3124V20.1133C6.79674 19.339 4.84877 17.5675 4.05768 15.3456C3.93561 15.4086 3.80664 15.4422 3.67379 15.4422C2.87493 15.4422 2.22705 14.2289 2.22705 12.7321C2.22705 11.5204 2.65149 10.4947 3.23683 10.1479L3.23683 4.75172H3.60391L3.60391 10.0254C3.6272 10.0232 3.65049 10.0224 3.67379 10.0224C3.90197 10.0224 4.11807 10.1216 4.31002 10.298C5.35561 8.07396 7.59602 6.39558 10.3265 5.88271C10.3265 5.88228 10.3265 5.88185 10.3265 5.88142C10.3265 5.18695 10.8281 4.59773 11.5247 4.3868L12.0907 1.46874L12.6566 4.3868C13.3532 4.59773 13.8549 5.18695 13.8549 5.88142C13.8549 5.88185 13.8549 5.88228 13.8549 5.88271C16.5857 6.39558 18.8262 8.07396 19.8713 10.298C20.0227 10.1591 20.1883 10.0681 20.3639 10.0357V4.75172H20.731V10.0543C21.4242 10.2553 21.9543 11.3781 21.9543 12.7325C21.9556 14.2289 21.3077 15.4422 20.5088 15.4422Z"
      fill="#FEFEFE"
    />
  </svg>
);

export const fileSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14"
      stroke="#B7B7B7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 10H18C15 10 14 9 14 6V2L22 10Z"
      stroke="#B7B7B7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 13H13"
      stroke="#B7B7B7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 17H11"
      stroke="#B7B7B7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const warningSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 9V14"
      stroke="#FFD1D9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9999 21.4103H5.93993C2.46993 21.4103 1.01993 18.9303 2.69993 15.9003L5.81993 10.2803L8.75993 5.00027C10.5399 1.79027 13.4599 1.79027 15.2399 5.00027L18.1799 10.2903L21.2999 15.9103C22.9799 18.9403 21.5199 21.4203 18.0599 21.4203H11.9999V21.4103Z"
      stroke="#FFD1D9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9946 17H12.0036"
      stroke="#FFD1D9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const alertSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 9V14"
      stroke="#FFE629"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9999 21.4098H5.93993C2.46993 21.4098 1.01993 18.9298 2.69993 15.8998L5.81993 10.2798L8.75993 4.99979C10.5399 1.78979 13.4599 1.78979 15.2399 4.99979L18.1799 10.2898L21.2999 15.9098C22.9799 18.9398 21.5199 21.4198 18.0599 21.4198H11.9999V21.4098Z"
      stroke="#FFE629"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9946 17H12.0036"
      stroke="#FFE629"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const hintCheck = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.9 8.1L4.5 9.5L9 14L19 4L17.6 2.6L9 11.2L5.9 8.1ZM18 10C18 14.4 14.4 18 10 18C5.6 18 2 14.4 2 10C2 5.6 5.6 2 10 2C10.8 2 11.5 2.1 12.2 2.3L13.8 0.7C12.6 0.3 11.3 0 10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10H18Z"
      fill="#FEFEFE"
    />
  </svg>
);

export const overviewSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 6.39V2.985C16.5 1.9275 16.02 1.5 14.8275 1.5H11.7975C10.605 1.5 10.125 1.9275 10.125 2.985V6.3825C10.125 7.4475 10.605 7.8675 11.7975 7.8675H14.8275C16.02 7.875 16.5 7.4475 16.5 6.39Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 14.8275V11.7975C16.5 10.605 16.02 10.125 14.8275 10.125H11.7975C10.605 10.125 10.125 10.605 10.125 11.7975V14.8275C10.125 16.02 10.605 16.5 11.7975 16.5H14.8275C16.02 16.5 16.5 16.02 16.5 14.8275Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.875 6.39V2.985C7.875 1.9275 7.395 1.5 6.2025 1.5H3.1725C1.98 1.5 1.5 1.9275 1.5 2.985V6.3825C1.5 7.4475 1.98 7.8675 3.1725 7.8675H6.2025C7.395 7.875 7.875 7.4475 7.875 6.39Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.875 14.8275V11.7975C7.875 10.605 7.395 10.125 6.2025 10.125H3.1725C1.98 10.125 1.5 10.605 1.5 11.7975V14.8275C1.5 16.02 1.98 16.5 3.1725 16.5H6.2025C7.395 16.5 7.875 16.02 7.875 14.8275Z"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const bizdevJobsSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00011 16.5H12.0001C15.0151 16.5 15.5551 15.2925 15.7126 13.8225L16.2751 7.8225C16.4776 5.9925 15.9526 4.5 12.7501 4.5H5.25011C2.04761 4.5 1.52261 5.9925 1.72511 7.8225L2.28761 13.8225C2.44511 15.2925 2.98511 16.5 6.00011 16.5Z"
      stroke="#888888"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 4.5V3.9C6 2.5725 6 1.5 8.4 1.5H9.6C12 1.5 12 2.5725 12 3.9V4.5"
      stroke="#888888"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 9.75V10.5C10.5 10.5075 10.5 10.5075 10.5 10.515C10.5 11.3325 10.4925 12 9 12C7.515 12 7.5 11.34 7.5 10.5225V9.75C7.5 9 7.5 9 8.25 9H9.75C10.5 9 10.5 9 10.5 9.75Z"
      stroke="#888888"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2375 8.25C14.505 9.51 12.525 10.26 10.5 10.515"
      stroke="#888888"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.96484 8.45215C3.65234 9.60715 5.55734 10.3046 7.49984 10.5221"
      stroke="#888888"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const chatSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1.5H6C3 1.5 1.5 3 1.5 6V15.75C1.5 16.1625 1.8375 16.5 2.25 16.5H12C15 16.5 16.5 15 16.5 12V6C16.5 3 15 1.5 12 1.5Z"
      stroke="#888888"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 7.125H12.75"
      stroke="#888888"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 10.875H10.5"
      stroke="#888888"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const demoSvg = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.2751 1.66699H7.7251V5.30033H12.2751V1.66699Z" fill="#FEFEFE" />
    <path
      d="M13.5249 1.66699V5.30033H18.2249C17.7999 3.00866 16.1082 1.67533 13.5249 1.66699Z"
      fill="#FEFEFE"
    />
    <path
      d="M1.66675 6.5498V13.4915C1.66675 16.5248 3.47508 18.3331 6.50841 18.3331H13.4917C16.5251 18.3331 18.3334 16.5248 18.3334 13.4915V6.5498H1.66675ZM12.0334 13.4831L10.3001 14.4831C9.93341 14.6915 9.57508 14.7998 9.24175 14.7998C8.99175 14.7998 8.76675 14.7415 8.55841 14.6248C8.07508 14.3498 7.80841 13.7831 7.80841 13.0498V11.0498C7.80841 10.3165 8.07508 9.7498 8.55841 9.4748C9.04175 9.19147 9.65841 9.24147 10.3001 9.61647L12.0334 10.6165C12.6751 10.9831 13.0251 11.4998 13.0251 12.0581C13.0251 12.6165 12.6667 13.1081 12.0334 13.4831Z"
      fill="#FEFEFE"
    />
    <path
      d="M6.4749 1.66699C3.89157 1.67533 2.1999 3.00866 1.7749 5.30033H6.4749V1.66699Z"
      fill="#FEFEFE"
    />
  </svg>
);

export const bizdevSvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.2 15H10.8C13.8 15 15 13.8 15 10.8V7.2C15 4.2 13.8 3 10.8 3H7.2C4.2 3 3 4.2 3 7.2V10.8C3 13.8 4.2 15 7.2 15Z"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.875 12.75H10.125C12 12.75 12.75 12 12.75 10.125V7.875C12.75 6 12 5.25 10.125 5.25H7.875C6 5.25 5.25 6 5.25 7.875V10.125C5.25 12 6 12.75 7.875 12.75Z"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.00732 3V1.5"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 3V1.5"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 3V1.5"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 6H16.5"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 9H16.5"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 12H16.5"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15V16.5"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.00732 15V16.5"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.00732 15V16.5"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 6H3"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 9H3"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 12H3"
      stroke="#FEFEFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const bizdevHintSvg = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00001 14.6663C11.6667 14.6663 14.6667 11.6663 14.6667 7.99967C14.6667 4.33301 11.6667 1.33301 8.00001 1.33301C4.33334 1.33301 1.33334 4.33301 1.33334 7.99967C1.33334 11.6663 4.33334 14.6663 8.00001 14.6663Z"
      stroke="#B7B7B7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 5.33301V8.66634"
      stroke="#B7B7B7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99634 10.667H8.00233"
      stroke="#B7B7B7"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const upgradePlan = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 11.75L14.3333 10.6667L13.25 8C13.1667 7.66667 12.8333 7.5 12.5 7.5C12.1667 7.5 11.8333 7.66667 11.75 8L10.6667 10.6667L8 11.75C7.66667 11.8333 7.5 12.1667 7.5 12.5C7.5 12.8333 7.66667 13.1667 8 13.25L10.6667 14.3333L11.75 17C11.9167 17.3333 12.1667 17.5 12.5 17.5C12.8333 17.5 13.1667 17.3333 13.25 17L14.3333 14.3333L17 13.25C17.3333 13.0833 17.5 12.8333 17.5 12.5C17.5 12.1667 17.3333 11.8333 17 11.75ZM13.4167 12.9167C13.25 13 13.0833 13.1667 13 13.3333L12.5 14.5L12.0833 13.4167C12 13.25 11.8333 13.0833 11.6667 13L10.5 12.5L11.5833 12.0833C11.75 12 11.9167 11.8333 12 11.6667L12.4167 10.5833L12.8333 11.6667C12.9167 11.8333 13.0833 12 13.25 12.0833L14.3333 12.5L13.4167 12.9167Z"
      fill="#888888"
    />
    <path
      d="M8.33366 8.91683C8.33366 8.5835 8.16699 8.25016 7.83366 8.16683L6.58366 7.5835L6.00033 6.3335C5.91699 6.00016 5.58366 5.8335 5.25033 5.8335C4.91699 5.8335 4.58366 6.00016 4.50033 6.3335L3.91699 7.5835L2.66699 8.16683C2.33366 8.3335 2.16699 8.5835 2.16699 8.91683C2.16699 9.25016 2.33366 9.5835 2.66699 9.66683L3.91699 10.2502L4.50033 11.5002C4.66699 11.8335 4.91699 12.0002 5.25033 12.0002C5.58366 12.0002 5.91699 11.8335 6.00033 11.5002L6.58366 10.2502L7.83366 9.66683C8.16699 9.5835 8.33366 9.25016 8.33366 8.91683ZM5.25033 9.0835C5.16699 9.00016 5.16699 8.91683 5.08366 8.91683C5.16699 8.8335 5.25033 8.8335 5.25033 8.75016C5.33366 8.8335 5.33366 8.91683 5.41699 8.91683C5.33366 9.00016 5.33366 9.00016 5.25033 9.0835Z"
      fill="#888888"
    />
    <path
      d="M11.8335 5.33333L12.5835 5.66667L12.9168 6.41667C13.0835 6.75 13.3335 6.91667 13.6668 6.91667C14.0002 6.91667 14.3335 6.75 14.4168 6.41667L14.7502 5.66667L15.5002 5.33333C15.8335 5.16667 16.0002 4.91667 16.0002 4.58333C16.0002 4.25 15.8335 3.91667 15.5002 3.83333L14.7502 3.5L14.4168 2.75C14.2502 2.41667 14.0002 2.25 13.6668 2.25C13.3335 2.25 13.0002 2.41667 12.9168 2.75L12.5835 3.5L11.8335 3.83333C11.5002 4 11.3335 4.25 11.3335 4.58333C11.3335 4.91667 11.5835 5.25 11.8335 5.33333Z"
      fill="#888888"
    />
  </svg>
);

export const collapseSvg = (
  <svg
    width="9"
    height="16"
    viewBox="0 0 9 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.85397 9.31152L4.95619 12.2093C4.61396 12.5515 4.05397 12.5515 3.71174 12.2093L0.813965 9.31152"
      stroke="#FEFEFE"
      strokeWidth="0.666667"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.85397 6.68911L4.95619 3.79133C4.61396 3.44911 4.05397 3.44911 3.71174 3.79133L0.813965 6.68911"
      stroke="#FEFEFE"
      strokeWidth="0.666667"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const changesWarningSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.7605 15.92L15.3605 4.4C14.5005 2.85 13.3105 2 12.0005 2C10.6905 2 9.50047 2.85 8.64047 4.4L2.24047 15.92C1.43047 17.39 1.34047 18.8 1.99047 19.91C2.64047 21.02 3.92047 21.63 5.60047 21.63H18.4005C20.0805 21.63 21.3605 21.02 22.0105 19.91C22.6605 18.8 22.5705 17.38 21.7605 15.92ZM11.2505 9C11.2505 8.59 11.5905 8.25 12.0005 8.25C12.4105 8.25 12.7505 8.59 12.7505 9V14C12.7505 14.41 12.4105 14.75 12.0005 14.75C11.5905 14.75 11.2505 14.41 11.2505 14V9ZM12.7105 17.71C12.6605 17.75 12.6105 17.79 12.5605 17.83C12.5005 17.87 12.4405 17.9 12.3805 17.92C12.3205 17.95 12.2605 17.97 12.1905 17.98C12.1305 17.99 12.0605 18 12.0005 18C11.9405 18 11.8705 17.99 11.8005 17.98C11.7405 17.97 11.6805 17.95 11.6205 17.92C11.5605 17.9 11.5005 17.87 11.4405 17.83C11.3905 17.79 11.3405 17.75 11.2905 17.71C11.1105 17.52 11.0005 17.26 11.0005 17C11.0005 16.74 11.1105 16.48 11.2905 16.29C11.3405 16.25 11.3905 16.21 11.4405 16.17C11.5005 16.13 11.5605 16.1 11.6205 16.08C11.6805 16.05 11.7405 16.03 11.8005 16.02C11.9305 15.99 12.0705 15.99 12.1905 16.02C12.2605 16.03 12.3205 16.05 12.3805 16.08C12.4405 16.1 12.5005 16.13 12.5605 16.17C12.6105 16.21 12.6605 16.25 12.7105 16.29C12.8905 16.48 13.0005 16.74 13.0005 17C13.0005 17.26 12.8905 17.52 12.7105 17.71Z"
      fill="#FFE629"
    />
  </svg>
);
